import {
	BlockResponse,
	GOFPaymentSummaryRequestData,
	PDFBlock
} from "@/Contracts/ProposalBuilder/Block";
import { replaceMergeTagsWithId } from "@/Utils/MergeTags";
import { TextBlockData } from "@/Contracts/ProposalBuilder/Block";
import { Action, Dispatch, ActionCreator } from "redux";
import { ThunkAction } from "redux-thunk";

import {
	EditorType,
	getQueryParamAuthDetails,
	QueryParamConstants,
	ZomentumWindow
} from "@/Contracts";
import {
	BlockMapper,
	Block,
	BlockType,
	createNewBlock,
	QuoteBlockData,
	QuoteProduct,
	QuoteSectionTypes,
	GridBlockData,
	BlockData,
	MultipleQuoteProductRequest,
	QuoteLabels,
	DefaultQuoteLabels,
	AddQuoteProductCatalogDrawerFormValues
} from "@/Contracts/ProposalBuilder/Block";

import { DocumentType } from "@/Contracts/Documents";

import {
	editBlock,
	editQuoteBlock,
	addBlock,
	editBlockFromClient,
	editBlockFromPublicClient,
	reorderChildrenBlock,
	cloneBlock,
	getBlock,
	getBlockList,
	calculatePaymentSummary
} from "@/ProposalBuilder/services/Block";
import { Document, PaymentSummary } from "@/Contracts/Documents";
import {
	calculateGrandTotal,
	calculateTax
} from "@/ProposalBuilder/components/BlockComponents/QuoteBlockComponent/QuoteBlockComponents/QuoteBlockUtils";
import { ProductType } from "@/Contracts/Products";
import { ProposalBuilderState } from "@/ProposalBuilder/store";
// TODO: fix it later
// import {
// 	DocumentDetailsUpdatedAction,
// 	DocumentsActionTypes,
// 	UpdateCurrentDocPaymentSummarySuccessfulAction
// } from "..";
import cloneDeep from "lodash/cloneDeep";
import {
	getGOFDocumentData,
	setGOFBlockData,
	setGOFPaymentData
} from "@/Utils/Documents";
import { ParentStateActionTypes } from "../Parent";
import { updateMergeTagsDisplayName } from "@/Utils/MergeTags";

declare let window: ZomentumWindow;

export enum BlocksActionTypes {
	SHOW_BLOCK_LOADER = "SHOW_BLOCK_LOADER",
	HIDE_BLOCK_LOADER = "HIDE_BLOCK_LOADER",
	GET_BLOCK_MAPPER_REQUESTED = "GET_BLOCK_MAPPER_REQUESTED",
	GET_BLOCK_MAPPER_SUCCESSFUL = "GET_BLOCK_MAPPER_SUCCESSFUL",
	GET_BLOCK_MAPPER_FAILED = "GET_BLOCK_MAPPER_FAILED",
	UPDATE_BLOCK_REQUESTED = "UPDATE_BLOCK_REQUESTED",
	UPDATE_BLOCK_SUCCESSFUL = "UPDATE_BLOCK_SUCCESSFUL",
	UPDATE_BLOCK_FAILED = "UPDATE_BLOCK_FAILED",
	DELETE_BLOCK_REQUESTED = "DELETE_BLOCK_REQUESTED",
	DELETE_BLOCK_SUCCESSFUL = "DELETE_BLOCK_SUCCESSFUL",
	DELETE_BLOCK_FAILED = "DELETE_BLOCK_FAILED",
	HIDE_BLOCK_REQUESTED = "HIDE_BLOCK_REQUESTED",
	HIDE_BLOCK_SUCCESSFUL = "HIDE_BLOCK_SUCCESSFUL",
	HIDE_BLOCK_FAILED = "HIDE_BLOCK_FAILED",
	UNHIDE_BLOCK_REQUESTED = "UNHIDE_BLOCK_REQUESTED",
	UNHIDE_BLOCK_SUCCESSFUL = "UNHIDE_BLOCK_SUCCESSFUL",
	UNHIDE_BLOCK_FAILED = "UNHIDE_BLOCK_FAILED",
	UPDATE_BLOCK_MAPPER_REQUESTED = "UPDATE_BLOCK_MAPPER_REQUESTED",
	UPDATE_BLOCK_MAPPER_SUCCESSFUL = "UPDATE_BLOCK_MAPPER_SUCCESSFUL",
	UPDATE_BLOCK_MAPPER_FAILED = "UPDATE_BLOCK_MAPPER_FAILED",
	CREATE_BLOCK_REQUESTED = "CREATE_BLOCK_REQUESTED",
	CREATE_BLOCK_SUCCESSFUL = "CREATE_BLOCK_SUCCESSFUL",
	CREATE_BLOCK_FAILED = "CREATE_BLOCK_FAILED",
	CREATE_BLOCK_FROM_LIBRARY_REQUESTED = "CREATE_BLOCK_FROM_LIBRARY_REQUESTED",
	CREATE_BLOCK_FROM_LIBRARY_SUCCESSFUL = "CREATE_BLOCK_FROM_LIBRARY_SUCCESSFUL",
	CREATE_BLOCK_FROM_LIBRARY_FAILED = "CREATE_BLOCK_FROM_LIBRARY_FAILED",
	UPDATE_BLOCK_FOCUS = "UPDATE_BLOCK_FOCUS",
	UPDATE_SECTION_FOCUS = "UPDATE_SECTION_FOCUS",
	RESET_BLOCK_FOCUS = "RESET_BLOCK_FOCUS",
	CLONE_BLOCK_REQUESTED = "CLONE_BLOCK_REQUESTED",
	CLONE_BLOCK_FAILED = "CLONE_BLOCK_FAILED",
	CLONE_BLOCK_SUCCESSFUL = "CLONE_BLOCK_SUCCESSFUL",
	FETCH_SINGLE_BLOCK_REQUESTED = "FETCH_SINGLE_BLOCK_REQUESTED",
	FETCH_SINGLE_BLOCK_SUCCESSFUL = "FETCH_SINGLE_BLOCK_SUCCESSFUL",
	FETCH_SINGLE_BLOCK_FAILED = "FETCH_SINGLE_BLOCK_FAILED",
	EDIT_QUOTE_LABEL_REQUESTED = "EDIT_QUOTE_LABEL_REQUESTED",
	EDIT_QUOTE_LABEL_FAILED = "EDIT_QUOTE_LABEL_FAILED",
	EDIT_QUOTE_LABEL_SUCCESSFUL = "EDIT_QUOTE_LABEL_SUCCESSFUL",

	UPDATE_QUOTE_BLOCK_LOADER_IDS = "UPDATE_QUOTE_BLOCK_LOADER_IDS",
	QUICKBOOKS_SYNC_TOOLTIP_SHOW = "QUICKBOOKS_SYNC_TOOLTIP_SHOW",
	QUICKBOOKS_SYNC_TOOLTIP_HIDE = "QUICKBOOKS_SYNC_TOOLTIP_HIDE",

	SHOW_INPUT_FIELD_POP_UP = "SHOW_INPUT_FIELD_POP_UP",
	HIDE_INPUT_FIELD_POP_UP = "HIDE_INPUT_FIELD_POP_UP",

	SHOW_BACKGROUND_COLOR_PICKER = "SHOW_BACKGROUND_COLOR_PICKER",
	HIDE_BACKGROUND_COLOR_PICKER = "HIDE_BACKGROUND_COLOR_PICKER",

	SHOW_PRODUCT_CONFIGURE_DRAWER = "SHOW_PRODUCT_CONFIGURE_DRAWER",
	HIDE_PRODUCT_CONFIGURE_DRAWER = "HIDE_PRODUCT_CONFIGURE_DRAWER",

	SHOW_IMPORT_PRODUCTS_TO_QUOTE_DRAWER = "SHOW_IMPORT_PRODUCTS_TO_QUOTE_DRAWER",
	HIDE_IMPORT_PRODUCTS_TO_QUOTE_DRAWER = "HIDE_IMPORT_PRODUCTS_TO_QUOTE_DRAWER",

	UPDATE_EDITOR_TYPE = "UPDATE_EDITOR_TYPE",

	// Update payment summary (total, discount, tax and adjustment fees)
	UPDATE_CURRENT_DOC_PAYMENT_SUMMARY_REQUESTED = "UPDATE_CURRENT_DOC_PAYMENT_SUMMARY_REQUESTED",
	UPDATE_CURRENT_DOC_PAYMENT_SUMMARY_SUCCESSFUL = "UPDATE_CURRENT_DOC_PAYMENT_SUMMARY_SUCCESSFUL",
	UPDATE_CURRENT_DOC_PAYMENT_SUMMARY_FAILED = "UPDATE_CURRENT_DOC_PAYMENT_SUMMARY_FAILED",

	UPDATE_HEADER_FOOTER_COLUMN_ID = "UPDATE_HEADER_FOOTER_COLUMN_ID"
}

export type ShowBlockLoaderAction = Action<BlocksActionTypes.SHOW_BLOCK_LOADER>;
export type HideBlockLoaderAction = Action<BlocksActionTypes.HIDE_BLOCK_LOADER>;
export type GetBlockMapperRequestedAction =
	Action<BlocksActionTypes.GET_BLOCK_MAPPER_REQUESTED>;
export interface GetBlockMapperSuccessfulAction
	extends Action<BlocksActionTypes.GET_BLOCK_MAPPER_SUCCESSFUL> {
	readonly blockMapper: BlockMapper;
}
export type GetBlockMapperFailedAction =
	Action<BlocksActionTypes.GET_BLOCK_MAPPER_FAILED>;
export type UpdateBlockMapperRequestedAction =
	Action<BlocksActionTypes.UPDATE_BLOCK_MAPPER_REQUESTED>;
export interface UpdateBlockMapperSuccessfulAction
	extends Action<BlocksActionTypes.UPDATE_BLOCK_MAPPER_SUCCESSFUL> {
	readonly blockMapper: BlockMapper;
}
export type UpdateBlockMapperFailedAction =
	Action<BlocksActionTypes.UPDATE_BLOCK_MAPPER_FAILED>;
export interface UpdateBlockFocusAction
	extends Action<BlocksActionTypes.UPDATE_BLOCK_FOCUS> {
	readonly currentActiveBlock: (string | null)[];
}
export interface UpdateSectionFocusAction
	extends Action<BlocksActionTypes.UPDATE_SECTION_FOCUS> {
	readonly currentActiveSection: number | null;
}
export type ResetBlockFocusAction = Action<BlocksActionTypes.RESET_BLOCK_FOCUS>;
export type CreateBlockRequestedAction =
	Action<BlocksActionTypes.CREATE_BLOCK_REQUESTED>;
export interface CreateBlockSuccessfulAction
	extends Action<BlocksActionTypes.CREATE_BLOCK_SUCCESSFUL> {
	readonly blockData: Block;
}
export type CreateBlockFailedAction =
	Action<BlocksActionTypes.CREATE_BLOCK_FAILED>;

export type UpdateBlockRequestedAction =
	Action<BlocksActionTypes.UPDATE_BLOCK_REQUESTED>;
export interface UpdateBlockSuccessfulAction
	extends Action<BlocksActionTypes.UPDATE_BLOCK_SUCCESSFUL> {
	blockData: Block;
	isQuoteBlock?: boolean;
}
export type UpdateBlockFailedAction =
	Action<BlocksActionTypes.UPDATE_BLOCK_FAILED>;

export type DeleteBlockRequestedAction =
	Action<BlocksActionTypes.DELETE_BLOCK_REQUESTED>;
export interface DeleteBlockSuccessfulAction
	extends Action<BlocksActionTypes.DELETE_BLOCK_SUCCESSFUL> {
	readonly blockMapper: BlockMapper;
}
export type DeleteBlockFailedAction =
	Action<BlocksActionTypes.DELETE_BLOCK_FAILED>;
export type HideBlockRequestedAction =
	Action<BlocksActionTypes.HIDE_BLOCK_REQUESTED>;
export interface HideBlockSuccessfulAction
	extends Action<BlocksActionTypes.HIDE_BLOCK_SUCCESSFUL> {
	blockData: Block;
}
export type HideBlockFailedAction = Action<BlocksActionTypes.HIDE_BLOCK_FAILED>;
export type UnhideBlockRequestedAction =
	Action<BlocksActionTypes.UNHIDE_BLOCK_REQUESTED>;
export interface UnhideBlockSuccessfulAction
	extends Action<BlocksActionTypes.UNHIDE_BLOCK_SUCCESSFUL> {
	blockData: Block;
}
export type UnhideBlockFailedAction =
	Action<BlocksActionTypes.UNHIDE_BLOCK_FAILED>;

export type CloneBlockRequestedAction =
	Action<BlocksActionTypes.CLONE_BLOCK_REQUESTED>;
export type CloneBlockFailedAction =
	Action<BlocksActionTypes.CLONE_BLOCK_FAILED>;
export interface CloneBlockSuccessfulAction
	extends Action<BlocksActionTypes.CLONE_BLOCK_SUCCESSFUL> {
	block: Block;
}

export type CreateBlockFromLibraryRequestedAction =
	Action<BlocksActionTypes.CREATE_BLOCK_FROM_LIBRARY_REQUESTED>;
export interface CreateBlockFromLibrarySuccessfulAction
	extends Action<BlocksActionTypes.CREATE_BLOCK_FROM_LIBRARY_SUCCESSFUL> {
	clonedBlockId: string;
}
export type CreateBlockFromLibraryFailedAction =
	Action<BlocksActionTypes.CREATE_BLOCK_FROM_LIBRARY_FAILED>;
export type EditQuoteLabelRequestedAction =
	Action<BlocksActionTypes.EDIT_QUOTE_LABEL_REQUESTED>;
export type EditQuoteLabelFailedAction =
	Action<BlocksActionTypes.EDIT_QUOTE_LABEL_FAILED>;
export interface EditQuoteLabelSuccessfulAction
	extends Action<BlocksActionTypes.EDIT_QUOTE_LABEL_SUCCESSFUL> {
	readonly blockData: Block;
}

export type FetchSingleBlockRequestedAction =
	Action<BlocksActionTypes.FETCH_SINGLE_BLOCK_REQUESTED>;
export type FetchSingleBlockFailedAction =
	Action<BlocksActionTypes.FETCH_SINGLE_BLOCK_FAILED>;
export interface FetchSingleBlockSuccessfulAction
	extends Action<BlocksActionTypes.FETCH_SINGLE_BLOCK_SUCCESSFUL> {
	block: Block;
}

export interface UpdateQuoteBlockLoaderIdsAction
	extends Action<BlocksActionTypes.UPDATE_QUOTE_BLOCK_LOADER_IDS> {
	readonly quoteBlockIds: string[];
}

export type QuickbooksTooltipShowAction =
	Action<BlocksActionTypes.QUICKBOOKS_SYNC_TOOLTIP_SHOW>;
export type QuickbooksTooltipHideAction =
	Action<BlocksActionTypes.QUICKBOOKS_SYNC_TOOLTIP_HIDE>;

export type ShowInputFieldPopUp =
	Action<BlocksActionTypes.SHOW_INPUT_FIELD_POP_UP>;

export type HideInputFieldPopUp =
	Action<BlocksActionTypes.HIDE_INPUT_FIELD_POP_UP>;

export type ShowBackgroundColorPicker =
	Action<BlocksActionTypes.SHOW_BACKGROUND_COLOR_PICKER>;

export type HideBackgroundColorPicker =
	Action<BlocksActionTypes.HIDE_BACKGROUND_COLOR_PICKER>;

export interface ShowProductConfigureDrawer
	extends Action<BlocksActionTypes.SHOW_PRODUCT_CONFIGURE_DRAWER> {
	productData: QuoteProduct;
	blockId: string;
	sectionIndex: number;
	readonly: boolean;
}

export type HideProductConfigureDrawer =
	Action<BlocksActionTypes.HIDE_PRODUCT_CONFIGURE_DRAWER>;

export interface ShowImportProductsToQuoteDrawer
	extends Action<BlocksActionTypes.SHOW_IMPORT_PRODUCTS_TO_QUOTE_DRAWER> {
	blockId: string;
	sectionIndex: number;
}

export type HideImportProductsToQuoteDrawer =
	Action<BlocksActionTypes.HIDE_IMPORT_PRODUCTS_TO_QUOTE_DRAWER>;

export interface UpdateEditorType
	extends Action<BlocksActionTypes.UPDATE_EDITOR_TYPE> {
	readonly editorType: EditorType;
}

export interface UpdateHeaderFooterColumnId
	extends Action<BlocksActionTypes.UPDATE_HEADER_FOOTER_COLUMN_ID> {
	readonly headerFooterColumnId: string | null;
}

export type BlocksActions =
	| ShowBlockLoaderAction
	| HideBlockLoaderAction
	| GetBlockMapperRequestedAction
	| GetBlockMapperSuccessfulAction
	| GetBlockMapperFailedAction
	| UpdateBlockMapperRequestedAction
	| UpdateBlockMapperSuccessfulAction
	| UpdateBlockMapperFailedAction
	| UpdateBlockFocusAction
	| UpdateSectionFocusAction
	| ResetBlockFocusAction
	| CreateBlockRequestedAction
	| CreateBlockSuccessfulAction
	| CreateBlockFailedAction
	| CreateBlockFromLibraryRequestedAction
	| CreateBlockFromLibrarySuccessfulAction
	| CreateBlockFromLibraryFailedAction
	| UpdateBlockRequestedAction
	| UpdateBlockSuccessfulAction
	| UpdateBlockFailedAction
	| DeleteBlockRequestedAction
	| DeleteBlockSuccessfulAction
	| DeleteBlockFailedAction
	| HideBlockRequestedAction
	| HideBlockSuccessfulAction
	| HideBlockFailedAction
	| UnhideBlockRequestedAction
	| UnhideBlockSuccessfulAction
	| UnhideBlockFailedAction
	| CloneBlockRequestedAction
	| CloneBlockFailedAction
	| CloneBlockSuccessfulAction
	| FetchSingleBlockRequestedAction
	| FetchSingleBlockFailedAction
	| FetchSingleBlockSuccessfulAction
	| EditQuoteLabelFailedAction
	| EditQuoteLabelSuccessfulAction
	| EditQuoteLabelRequestedAction
	| UpdateQuoteBlockLoaderIdsAction
	| QuickbooksTooltipShowAction
	| QuickbooksTooltipHideAction
	| ShowInputFieldPopUp
	| HideInputFieldPopUp
	| ShowBackgroundColorPicker
	| HideBackgroundColorPicker
	| ShowProductConfigureDrawer
	| HideProductConfigureDrawer
	| ShowImportProductsToQuoteDrawer
	| HideImportProductsToQuoteDrawer
	| UpdateEditorType
	| UpdateHeaderFooterColumnId;

export interface BlocksDispatch {
	addBlockToGrid: ActionCreator<
		ThunkAction<
			Promise<UpdateBlockSuccessfulAction>,
			ProposalBuilderState,
			{ blockType: BlockType; parentId: string; positionIndex: number },
			UpdateBlockSuccessfulAction
		>
	>;
	addBlockToImage: ActionCreator<
		ThunkAction<
			Promise<UpdateBlockSuccessfulAction>,
			ProposalBuilderState,
			{
				blockType: BlockType;
				parentId: string;
				positionIndex: number;
			},
			UpdateBlockSuccessfulAction
		>
	>;
	addChildBlockToPDF: ActionCreator<
		ThunkAction<
			Promise<UpdateBlockSuccessfulAction>,
			ProposalBuilderState,
			PDFBlock,
			UpdateBlockSuccessfulAction
		>
	>;
	addBlockToVideo: ActionCreator<
		ThunkAction<
			Promise<UpdateBlockSuccessfulAction>,
			ProposalBuilderState,
			{
				blockType: BlockType;
				parentId: string;
				positionIndex: number;
			},
			UpdateBlockSuccessfulAction
		>
	>;
	resizeGridBlock: ActionCreator<
		ThunkAction<
			Promise<UpdateBlockSuccessfulAction>,
			ProposalBuilderState,
			Block,
			UpdateBlockSuccessfulAction
		>
	>;
	deleteChildBlockFromParentBlock: ActionCreator<
		ThunkAction<
			Promise<UpdateBlockSuccessfulAction>,
			ProposalBuilderState,
			{
				parentId: string;
				childId: string;
				replaceChildBlockWithNull: boolean;
			},
			UpdateBlockSuccessfulAction
		>
	>;
	showBlockLoader: ActionCreator<
		ThunkAction<
			ShowBlockLoaderAction,
			ProposalBuilderState,
			null,
			ShowBlockLoaderAction
		>
	>;
	hideBlockLoader: ActionCreator<
		ThunkAction<
			HideBlockLoaderAction,
			ProposalBuilderState,
			null,
			HideBlockLoaderAction
		>
	>;
	resetBlockFocus: ActionCreator<
		ThunkAction<
			ResetBlockFocusAction,
			ProposalBuilderState,
			null,
			ResetBlockFocusAction
		>
	>;
	deleteBlock: ActionCreator<
		ThunkAction<
			Promise<DeleteBlockSuccessfulAction>,
			ProposalBuilderState,
			{ blockIds: string[] },
			DeleteBlockSuccessfulAction
		>
	>;
	hideBlock: ActionCreator<
		ThunkAction<
			Promise<HideBlockSuccessfulAction>,
			ProposalBuilderState,
			{ blockId: string },
			HideBlockSuccessfulAction
		>
	>;
	unhideBlock: ActionCreator<
		ThunkAction<
			Promise<UnhideBlockSuccessfulAction>,
			ProposalBuilderState,
			{ blockId: string },
			UnhideBlockSuccessfulAction
		>
	>;
	updateBlock: ActionCreator<
		ThunkAction<
			Promise<UpdateBlockSuccessfulAction>,
			ProposalBuilderState,
			Block,
			UpdateBlockSuccessfulAction
		>
	>;

	updateBlockFromClient: ActionCreator<
		ThunkAction<
			Promise<UpdateBlockSuccessfulAction>,
			ProposalBuilderState,
			Block,
			UpdateBlockSuccessfulAction
		>
	>;
	updateBlockData: ActionCreator<
		ThunkAction<
			Promise<UpdateBlockSuccessfulAction>,
			ProposalBuilderState,
			{
				blockId: string;
				blockData: Partial<BlockData>;
			},
			UpdateBlockSuccessfulAction
		>
	>;
	updateBlockFocus: ActionCreator<
		ThunkAction<
			UpdateBlockFocusAction,
			ProposalBuilderState,
			string,
			UpdateBlockFocusAction
		>
	>;
	updateChildFocus: ActionCreator<
		ThunkAction<
			UpdateBlockFocusAction,
			ProposalBuilderState,
			{ parentId: string; childId: string },
			UpdateBlockFocusAction
		>
	>;
	updateSectionFocus: ActionCreator<
		ThunkAction<
			UpdateSectionFocusAction,
			ProposalBuilderState,
			string,
			UpdateSectionFocusAction
		>
	>;
	repositionProductsInQuoteBlock: ActionCreator<
		ThunkAction<
			Promise<UpdateBlockSuccessfulAction>,
			ProposalBuilderState,
			{
				blockId: string;
				sectionIndex: number;
				sourceIndex: number;
				destIndex: number;
			},
			UpdateBlockSuccessfulAction
		>
	>;
	repositionSectionsInQuoteBlock: ActionCreator<
		ThunkAction<
			UpdateBlockSuccessfulAction,
			ProposalBuilderState,
			{ blockId: string; sourceIndex: number; destIndex: number },
			UpdateBlockSuccessfulAction
		>
	>;
	repositionProductsAcrossSectionsInQuoteBlock: ActionCreator<
		ThunkAction<
			Promise<UpdateBlockSuccessfulAction>,
			ProposalBuilderState,
			{
				blockId: string;
				productId: string;
				sourceSectionIndex: number;
				destSectionIndex: number;
				sourceIndex: number;
				destIndex: number;
			},
			UpdateBlockSuccessfulAction
		>
	>;
	addProductInQuoteBlockSection: ActionCreator<
		ThunkAction<
			Promise<UpdateBlockSuccessfulAction>,
			ProposalBuilderState,
			AddProductToQuoteBlockArgs,
			UpdateBlockSuccessfulAction
		>
	>;
	editProductInQuoteBlockSectionFromDrawer: ActionCreator<
		ThunkAction<
			Promise<UpdateBlockSuccessfulAction>,
			ProposalBuilderState,
			AddProductToQuoteBlockArgs,
			UpdateBlockSuccessfulAction
		>
	>;
	addMultipleProductsInQuoteBlockSection: ActionCreator<
		ThunkAction<
			Promise<UpdateBlockSuccessfulAction>,
			ProposalBuilderState,
			MultipleQuoteProductRequest,
			UpdateBlockSuccessfulAction
		>
	>;
	handleProductInQuoteBlockSelectChangeFromClient: ActionCreator<
		ThunkAction<
			Promise<UpdateBlockSuccessfulAction>,
			ProposalBuilderState,
			{
				blockId: string;
				sectionIndex: number;
				quoteProductId: string;
				checked: boolean;
			},
			UpdateBlockSuccessfulAction
		>
	>;
	updateProductDetails: ActionCreator<
		ThunkAction<
			Promise<UpdateBlockSuccessfulAction>,
			ProposalBuilderState,
			{
				blockId: string;
				sectionIndex: number;
				quoteProductId: string;
				data: Partial<QuoteProduct>;
				isFromUser: boolean;
				updateChild?: boolean;
				setAsGlobal?: boolean;
				setupFeeLabel?: string;
			},
			UpdateBlockSuccessfulAction
		>
	>;

	cloneBlock: ActionCreator<
		ThunkAction<
			Promise<CloneBlockSuccessfulAction>,
			ProposalBuilderState,
			{
				blockId: string;
				destinationDocumentId?: string;
			},
			CloneBlockSuccessfulAction
		>
	>;
	createBlockFromLibrary: ActionCreator<
		ThunkAction<
			Promise<CreateBlockFromLibrarySuccessfulAction>,
			ProposalBuilderState,
			{
				blockId: string;
				destinationDocumentId?: string;
			},
			CreateBlockFromLibrarySuccessfulAction
		>
	>;
	updateDocumentBlockMapper: ActionCreator<
		ThunkAction<
			Promise<UpdateBlockMapperSuccessfulAction>,
			ProposalBuilderState,
			null,
			UpdateBlockMapperSuccessfulAction
		>
	>;
	fetchMissingBlockAndAddToMapper: ActionCreator<
		ThunkAction<
			Promise<FetchSingleBlockSuccessfulAction>,
			ProposalBuilderState,
			string,
			FetchSingleBlockSuccessfulAction
		>
	>;
	editQuoteLabel: ActionCreator<
		ThunkAction<
			Promise<EditQuoteLabelSuccessfulAction>,
			ProposalBuilderState,
			{
				blockId: string;
				key: keyof string;
				value: string;
				setAsGlobal: boolean;
				productIndex: number;
				sectionIndex: number;
			},
			EditQuoteLabelSuccessfulAction
		>
	>;
	updateQuoteBlockLoaderIds: ActionCreator<
		ThunkAction<
			UpdateQuoteBlockLoaderIdsAction,
			ProposalBuilderState,
			string[],
			UpdateQuoteBlockLoaderIdsAction
		>
	>;
	showQuickbooksTooltip: ActionCreator<
		ThunkAction<
			QuickbooksTooltipShowAction,
			ProposalBuilderState,
			null,
			QuickbooksTooltipShowAction
		>
	>;
	hideQuickbooksTooltip: ActionCreator<
		ThunkAction<
			QuickbooksTooltipHideAction,
			ProposalBuilderState,
			null,
			QuickbooksTooltipHideAction
		>
	>;
	showInputFieldPopUp: ActionCreator<
		ThunkAction<
			ShowInputFieldPopUp,
			ProposalBuilderState,
			null,
			ShowInputFieldPopUp
		>
	>;
	hideInputFieldPopUp: ActionCreator<
		ThunkAction<
			HideInputFieldPopUp,
			ProposalBuilderState,
			null,
			HideInputFieldPopUp
		>
	>;
	showBackgroundColorPicker: ActionCreator<
		ThunkAction<
			ShowBackgroundColorPicker,
			ProposalBuilderState,
			null,
			ShowBackgroundColorPicker
		>
	>;
	hideBackgroundColorPicker: ActionCreator<
		ThunkAction<
			HideBackgroundColorPicker,
			ProposalBuilderState,
			null,
			HideBackgroundColorPicker
		>
	>;
	showProductConfigureDrawer: ActionCreator<
		ThunkAction<
			ShowProductConfigureDrawer,
			ProposalBuilderState,
			{
				productData: QuoteProduct;
				blockId: string;
				sectionIndex: number;
				readonly: boolean;
			},
			ShowProductConfigureDrawer
		>
	>;
	hideProductConfigureDrawer: ActionCreator<
		ThunkAction<
			HideProductConfigureDrawer,
			ProposalBuilderState,
			null,
			HideProductConfigureDrawer
		>
	>;
	showImportProductsToQuoteDrawer: ActionCreator<
		ThunkAction<
			ShowImportProductsToQuoteDrawer,
			ProposalBuilderState,
			{
				blockId: string;
				sectionIndex: number;
			},
			ShowImportProductsToQuoteDrawer
		>
	>;
	hideImportProductsToQuoteDrawer: ActionCreator<
		ThunkAction<
			HideImportProductsToQuoteDrawer,
			ProposalBuilderState,
			null,
			HideImportProductsToQuoteDrawer
		>
	>;
	updateEditorType: ActionCreator<
		ThunkAction<
			UpdateEditorType,
			ProposalBuilderState,
			EditorType,
			UpdateEditorType
		>
	>;
	updateHeaderFooterColumnId: ActionCreator<
		ThunkAction<
			UpdateHeaderFooterColumnId,
			ProposalBuilderState,
			string | null,
			UpdateHeaderFooterColumnId
		>
	>;
}

export interface AddProductToQuoteBlockArgs {
	quoteProductFormValues: AddQuoteProductCatalogDrawerFormValues;
	blockId: string;
	sectionIndex: number;
	isFromUser?: boolean;
	productPosition?: number;
}

export const BlocksActionCreators: BlocksDispatch = {
	addBlockToGrid:
		({
			blockType,
			parentId,
			positionIndex
		}: {
			blockType: BlockType;
			parentId: string;
			positionIndex: number;
		}) =>
		async (
			dispatch: Dispatch,
			getState: () => ProposalBuilderState
		): Promise<UpdateBlockSuccessfulAction> => {
			try {
				// creating the block
				const createBlockRequestedAction: CreateBlockRequestedAction = {
					type: BlocksActionTypes.CREATE_BLOCK_REQUESTED
				};
				dispatch(createBlockRequestedAction);

				const blockDataRequest = createNewBlock(blockType);

				// making api call
				const blockDataResponse = await addBlock(blockDataRequest);
				const { payment_summary: paymentSummary, ...updatedBlock } =
					blockDataResponse;
				const createBlockSuccessfulAction: CreateBlockSuccessfulAction =
					{
						type: BlocksActionTypes.CREATE_BLOCK_SUCCESSFUL,
						blockData: updatedBlock
					};
				dispatch(createBlockSuccessfulAction);

				try {
					// updating the gridBlock
					const updateGridBlockAction: UpdateBlockRequestedAction = {
						type: BlocksActionTypes.UPDATE_BLOCK_REQUESTED
					};
					dispatch(updateGridBlockAction);
					const gridBlock = cloneDeep(
						getState().blocks.blockMapper[parentId]
					);

					if (
						!gridBlock.children_blocks ||
						gridBlock.children_blocks.length - 1 < positionIndex
					) {
						console.warn(
							"Invalid Children blocks, Grid Block::",
							gridBlock.children_blocks
						);
					}
					const gridBlockData = gridBlock.data as GridBlockData;

					const emptyNullPaddedChildBlocks = new Array(
						gridBlockData.columns * gridBlockData.rows
					)
						.fill(null)
						.map(
							(v, i) =>
								(gridBlock.children_blocks &&
									gridBlock.children_blocks[i]) ||
								v
						);

					gridBlock.children_blocks = [...emptyNullPaddedChildBlocks];

					// throw new Error('The children blocks is not valid');
					gridBlock.children_blocks[positionIndex] =
						blockDataResponse.id;

					// update the children blocks
					const updatedGridBlockResponse = await reorderChildrenBlock(
						gridBlock
					);

					const updateBlockFocusAction: UpdateBlockFocusAction = {
						type: BlocksActionTypes.UPDATE_BLOCK_FOCUS,
						currentActiveBlock: [parentId, blockDataResponse.id]
					};
					dispatch(updateBlockFocusAction);

					const updateGridBlockSuccessfulAction: UpdateBlockSuccessfulAction =
						{
							type: BlocksActionTypes.UPDATE_BLOCK_SUCCESSFUL,
							blockData: updatedGridBlockResponse
						};
					return dispatch(updateGridBlockSuccessfulAction);
				} catch (error) {
					const updateGridBlockFailedAction: UpdateBlockFailedAction =
						{
							type: BlocksActionTypes.UPDATE_BLOCK_FAILED
						};
					dispatch(updateGridBlockFailedAction);
					throw error;
				}
			} catch (error) {
				console.error(error);
				const createBlockFailedAction: CreateBlockFailedAction = {
					type: BlocksActionTypes.CREATE_BLOCK_FAILED
				};
				dispatch(createBlockFailedAction);

				return Promise.reject(error);
			}
		},
	addBlockToImage:
		({
			blockType,
			parentId,
			positionIndex
		}: {
			blockType: BlockType;
			parentId: string;
			positionIndex: number;
		}) =>
		async (
			dispatch: Dispatch,
			getState: () => ProposalBuilderState
		): Promise<UpdateBlockSuccessfulAction> => {
			try {
				// creating the block
				const createBlockRequestedAction: CreateBlockRequestedAction = {
					type: BlocksActionTypes.CREATE_BLOCK_REQUESTED
				};
				dispatch(createBlockRequestedAction);

				const blockDataRequest = createNewBlock(blockType);

				// making api call
				const blockDataResponse = await addBlock(blockDataRequest);
				const { payment_summary: paymentSummary, ...blockData } =
					blockDataResponse;

				const createBlockSuccessfulAction: CreateBlockSuccessfulAction =
					{
						type: BlocksActionTypes.CREATE_BLOCK_SUCCESSFUL,
						blockData
					};
				// const updateCurrentDocPaymentSummarySuccessfulAction: UpdateCurrentDocPaymentSummarySuccessfulAction =
				// 	{
				// 		type: DocumentsActionTypes.UPDATE_CURRENT_DOC_PAYMENT_SUMMARY_SUCCESSFUL,
				// 		paymentSummary
				// 	};
				// dispatch(updateCurrentDocPaymentSummarySuccessfulAction);
				dispatch({
					type: ParentStateActionTypes.UPDATE_CURRENT_DOC_PAYMENT_SUMMARY_SUCCESSFUL,
					paymentSummary
				});
				dispatch(createBlockSuccessfulAction);

				try {
					// updating the imageBlock
					const updateImageBlockAction: UpdateBlockRequestedAction = {
						type: BlocksActionTypes.UPDATE_BLOCK_REQUESTED
					};
					dispatch(updateImageBlockAction);
					const imageBlock = cloneDeep(
						getState().blocks.blockMapper[parentId]
					);

					if (
						!imageBlock.children_blocks ||
						imageBlock.children_blocks.length - 1 < positionIndex
					) {
						console.warn(
							"Invalid Children blocks, Image Block::",
							imageBlock.children_blocks
						);
					}

					if (!imageBlock.children_blocks) {
						imageBlock.children_blocks = new Array<string | null>();
					}

					// throw new Error('The children blocks is not valid');
					imageBlock.children_blocks[positionIndex] =
						blockDataResponse.id;

					// update the children blocks
					const updatedImageBlockResponse =
						await reorderChildrenBlock(imageBlock);

					const updateBlockFocusAction: UpdateBlockFocusAction = {
						type: BlocksActionTypes.UPDATE_BLOCK_FOCUS,
						currentActiveBlock: [parentId, blockDataResponse.id]
					};
					dispatch(updateBlockFocusAction);

					const updateImageBlockSuccessfulAction: UpdateBlockSuccessfulAction =
						{
							type: BlocksActionTypes.UPDATE_BLOCK_SUCCESSFUL,
							blockData: updatedImageBlockResponse
						};
					return dispatch(updateImageBlockSuccessfulAction);
				} catch (error) {
					const updateImageBlockFailedAction: UpdateBlockFailedAction =
						{
							type: BlocksActionTypes.UPDATE_BLOCK_FAILED
						};
					dispatch(updateImageBlockFailedAction);
					throw error;
				}
			} catch (error) {
				console.error(error);
				const createBlockFailedAction: CreateBlockFailedAction = {
					type: BlocksActionTypes.CREATE_BLOCK_FAILED
				};
				dispatch(createBlockFailedAction);

				return Promise.reject(error);
			}
		},
	addChildBlockToPDF:
		({ blockType, parentId, pageId, position }: PDFBlock) =>
		async (
			dispatch: Dispatch,
			getState: () => ProposalBuilderState
		): Promise<UpdateBlockSuccessfulAction> => {
			try {
				// creating the block
				const createBlockRequestedAction: CreateBlockRequestedAction = {
					type: BlocksActionTypes.CREATE_BLOCK_REQUESTED
				};
				dispatch(createBlockRequestedAction);

				const blockDataRequest = createNewBlock(blockType);

				if (!!position) {
					blockDataRequest.position = position;
				}

				// making api call
				const blockDataResponse = await addBlock(blockDataRequest);
				const { payment_summary: paymentSummary, ...blockData } =
					blockDataResponse;

				const createBlockSuccessfulAction: CreateBlockSuccessfulAction =
					{
						type: BlocksActionTypes.CREATE_BLOCK_SUCCESSFUL,
						blockData: blockData
					};

				dispatch(createBlockSuccessfulAction);
				// const updateCurrentDocPaymentSummarySuccessfulAction: UpdateCurrentDocPaymentSummarySuccessfulAction =
				// 	{
				// 		type: DocumentsActionTypes.UPDATE_CURRENT_DOC_PAYMENT_SUMMARY_SUCCESSFUL,
				// 		paymentSummary
				// 	};
				// dispatch(updateCurrentDocPaymentSummarySuccessfulAction);
				dispatch({
					type: ParentStateActionTypes.UPDATE_CURRENT_DOC_PAYMENT_SUMMARY_SUCCESSFUL,
					paymentSummary
				});

				try {
					// updating the PDF Block
					const updatePDFBlockAction: UpdateBlockRequestedAction = {
						type: BlocksActionTypes.UPDATE_BLOCK_REQUESTED
					};
					dispatch(updatePDFBlockAction);

					const pdfBlock = cloneDeep(
						getState().blocks.blockMapper[parentId]
					);

					if (!pdfBlock.children_blocks) {
						console.warn(
							"Invalid Children blocks, PDF Block::",
							pdfBlock.children_blocks
						);
					}

					if (!pdfBlock.children_blocks) {
						pdfBlock.children_blocks = new Array<string | null>();
					}

					// throw new Error('The children blocks is not valid');
					pdfBlock.children_blocks.push(blockDataResponse.id);

					// update the children blocks
					const updatedPdfBlockResponse = await reorderChildrenBlock(
						pdfBlock
					);

					const pdfCurrentPageId = `pdf-document-${
						pdfBlock.id
					}-page-${pageId.split("-")[1]}`;
					const textBlock = cloneDeep(
						getState().blocks.blockMapper[blockDataResponse.id]
					);

					const blockPosition = position
						? position
						: {
								top: (
									document.getElementById(
										pdfCurrentPageId
									) as HTMLElement
								).offsetTop,
								left: 0
						  };

					const updatedTextBlock = {
						...textBlock,
						position: blockPosition
					};

					const updateChildBlockAction: UpdateBlockSuccessfulAction =
						{
							type: BlocksActionTypes.UPDATE_BLOCK_SUCCESSFUL,
							blockData: updatedTextBlock
						};
					dispatch(updateChildBlockAction);

					const updateBlockFocusAction: UpdateBlockFocusAction = {
						type: BlocksActionTypes.UPDATE_BLOCK_FOCUS,
						currentActiveBlock: [parentId, blockDataResponse.id]
					};
					dispatch(updateBlockFocusAction);

					const updatePdfBlockSuccessfulAction: UpdateBlockSuccessfulAction =
						{
							type: BlocksActionTypes.UPDATE_BLOCK_SUCCESSFUL,
							blockData: updatedPdfBlockResponse
						};
					return dispatch(updatePdfBlockSuccessfulAction);
				} catch (error) {
					const updatePdfBlockFailedAction: UpdateBlockFailedAction =
						{
							type: BlocksActionTypes.UPDATE_BLOCK_FAILED
						};
					dispatch(updatePdfBlockFailedAction);
					throw error;
				}
			} catch (error) {
				console.error(error);
				const createBlockFailedAction: CreateBlockFailedAction = {
					type: BlocksActionTypes.CREATE_BLOCK_FAILED
				};
				dispatch(createBlockFailedAction);

				return Promise.reject(error);
			}
		},
	addBlockToVideo:
		({
			blockType,
			parentId,
			positionIndex
		}: {
			blockType: BlockType;
			parentId: string;
			positionIndex: number;
		}) =>
		async (
			dispatch: Dispatch,
			getState: () => ProposalBuilderState
		): Promise<UpdateBlockSuccessfulAction> => {
			try {
				// creating the block
				const createBlockRequestedAction: CreateBlockRequestedAction = {
					type: BlocksActionTypes.CREATE_BLOCK_REQUESTED
				};
				dispatch(createBlockRequestedAction);

				const blockDataRequest = createNewBlock(blockType);

				// making api call
				const blockDataResponse = await addBlock(blockDataRequest);
				const { payment_summary: paymentSummary, ...blockData } =
					blockDataResponse;
				const createBlockSuccessfulAction: CreateBlockSuccessfulAction =
					{
						type: BlocksActionTypes.CREATE_BLOCK_SUCCESSFUL,
						blockData
					};
				dispatch(createBlockSuccessfulAction);
				// const updateCurrentDocPaymentSummarySuccessfulAction: UpdateCurrentDocPaymentSummarySuccessfulAction =
				// 	{
				// 		type: DocumentsActionTypes.UPDATE_CURRENT_DOC_PAYMENT_SUMMARY_SUCCESSFUL,
				// 		paymentSummary
				// 	};
				// dispatch(updateCurrentDocPaymentSummarySuccessfulAction);
				dispatch({
					type: ParentStateActionTypes.UPDATE_CURRENT_DOC_PAYMENT_SUMMARY_SUCCESSFUL,
					paymentSummary
				});
				try {
					// updating the videoBlock
					const updateVideoBlockAction: UpdateBlockRequestedAction = {
						type: BlocksActionTypes.UPDATE_BLOCK_REQUESTED
					};
					dispatch(updateVideoBlockAction);
					const videoBlock = cloneDeep(
						getState().blocks.blockMapper[parentId]
					);

					if (
						!videoBlock.children_blocks ||
						videoBlock.children_blocks.length - 1 < positionIndex
					) {
						console.warn(
							"Invalid Children blocks, video block::",
							videoBlock.children_blocks
						);
					}

					if (!videoBlock.children_blocks) {
						videoBlock.children_blocks = new Array<string | null>();
					}

					// throw new Error('The children blocks is not valid');
					videoBlock.children_blocks[positionIndex] =
						blockDataResponse.id;

					// update the children blocks
					const updatedVideoBlockResponse =
						await reorderChildrenBlock(videoBlock);

					const updateBlockFocusAction: UpdateBlockFocusAction = {
						type: BlocksActionTypes.UPDATE_BLOCK_FOCUS,
						currentActiveBlock: [parentId, blockDataResponse.id]
					};
					dispatch(updateBlockFocusAction);

					const updateVideoBlockSuccessfulAction: UpdateBlockSuccessfulAction =
						{
							type: BlocksActionTypes.UPDATE_BLOCK_SUCCESSFUL,
							blockData: updatedVideoBlockResponse
						};
					return dispatch(updateVideoBlockSuccessfulAction);
				} catch (error) {
					const updateVideoBlockFailedAction: UpdateBlockFailedAction =
						{
							type: BlocksActionTypes.UPDATE_BLOCK_FAILED
						};
					dispatch(updateVideoBlockFailedAction);
					throw error;
				}
			} catch (error) {
				console.error(error);
				const createBlockFailedAction: CreateBlockFailedAction = {
					type: BlocksActionTypes.CREATE_BLOCK_FAILED
				};
				dispatch(createBlockFailedAction);

				return Promise.reject(error);
			}
		},
	resizeGridBlock:
		(gridBlock: Block) =>
		async (dispatch: Dispatch): Promise<UpdateBlockSuccessfulAction> => {
			try {
				// updating the gridBlock
				const updateGridBlockAction: UpdateBlockRequestedAction = {
					type: BlocksActionTypes.UPDATE_BLOCK_REQUESTED
				};
				dispatch(updateGridBlockAction);

				// update the children blocks
				const updateBlockResponse = await editBlock(gridBlock);
				const { children_blocks } = await reorderChildrenBlock(
					gridBlock
				);
				const { payment_summary: paymentSummary, ...blockData } =
					updateBlockResponse;
				const updateGridBlockSuccessfulAction: UpdateBlockSuccessfulAction =
					{
						type: BlocksActionTypes.UPDATE_BLOCK_SUCCESSFUL,
						blockData: {
							...blockData,
							children_blocks
						}
					};

				// const updateCurrentDocPaymentSummarySuccessfulAction: UpdateCurrentDocPaymentSummarySuccessfulAction =
				// 	{
				// 		type: DocumentsActionTypes.UPDATE_CURRENT_DOC_PAYMENT_SUMMARY_SUCCESSFUL,
				// 		paymentSummary
				// 	};
				// dispatch(updateCurrentDocPaymentSummarySuccessfulAction);
				dispatch({
					type: ParentStateActionTypes.UPDATE_CURRENT_DOC_PAYMENT_SUMMARY_SUCCESSFUL,
					paymentSummary
				});
				return dispatch(updateGridBlockSuccessfulAction);
			} catch (error) {
				const updateGridBlockFailedAction: UpdateBlockFailedAction = {
					type: BlocksActionTypes.UPDATE_BLOCK_FAILED
				};
				dispatch(updateGridBlockFailedAction);
				throw error;
			}
		},
	deleteChildBlockFromParentBlock:
		({
			parentId,
			childBlockId,
			replaceChildBlockWithNull
		}: {
			parentId: string;
			childBlockId: string;
			replaceChildBlockWithNull: boolean;
		}) =>
		async (
			dispatch: Dispatch,
			getState: () => ProposalBuilderState
		): Promise<UpdateBlockSuccessfulAction> => {
			try {
				// updating the parent block
				const updateParentBlockAction: UpdateBlockRequestedAction = {
					type: BlocksActionTypes.UPDATE_BLOCK_REQUESTED
				};
				dispatch(updateParentBlockAction);
				const parentBlock = cloneDeep(
					getState().blocks.blockMapper[parentId]
				);
				if (
					!parentBlock.children_blocks ||
					!parentBlock.children_blocks.length
				) {
					throw new Error("The children blocks is not valid");
				}

				let childrenBlocks = [...parentBlock.children_blocks];

				const updateBlockFocusAction: UpdateBlockFocusAction = {
					type: BlocksActionTypes.UPDATE_BLOCK_FOCUS,
					currentActiveBlock: [parentId, null]
				};
				dispatch(updateBlockFocusAction);

				if (replaceChildBlockWithNull) {
					childrenBlocks = childrenBlocks.map(currBlockId =>
						!!currBlockId && currBlockId === childBlockId
							? null
							: currBlockId
					);
				} else {
					childrenBlocks = childrenBlocks.filter(
						currBlockId =>
							!!currBlockId && currBlockId !== childBlockId
					);
				}
				parentBlock.children_blocks = childrenBlocks;

				const updatedParentBlockResponse = await reorderChildrenBlock(
					parentBlock
				);
				const updateParentBlockSuccessfulAction: UpdateBlockSuccessfulAction =
					{
						type: BlocksActionTypes.UPDATE_BLOCK_SUCCESSFUL,
						blockData: updatedParentBlockResponse
					};

				const response = dispatch(updateParentBlockSuccessfulAction);

				//deleting child block from blockmapper
				const newBlockMapper = {
					...getState().blocks.blockMapper
				};
				delete newBlockMapper[childBlockId];
				const getBlockMapperSuccessfulAction: GetBlockMapperSuccessfulAction =
					{
						type: BlocksActionTypes.GET_BLOCK_MAPPER_SUCCESSFUL,
						blockMapper: newBlockMapper
					};
				dispatch(getBlockMapperSuccessfulAction);

				return response;
			} catch (error) {
				const updateParentBlockFailedAction: UpdateBlockFailedAction = {
					type: BlocksActionTypes.UPDATE_BLOCK_FAILED
				};
				dispatch(updateParentBlockFailedAction);
				throw Promise.reject(error);
			}
		},
	showBlockLoader: () => {
		return (dispatch: Dispatch): ShowBlockLoaderAction => {
			const showBlockLoaderAction: ShowBlockLoaderAction = {
				type: BlocksActionTypes.SHOW_BLOCK_LOADER
			};
			return dispatch(showBlockLoaderAction);
		};
	},
	hideBlockLoader: () => {
		return (dispatch: Dispatch): HideBlockLoaderAction => {
			const hideBlockLoaderAction: HideBlockLoaderAction = {
				type: BlocksActionTypes.HIDE_BLOCK_LOADER
			};
			return dispatch(hideBlockLoaderAction);
		};
	},
	deleteBlock: ({ blockIds }: { blockIds: string[] }) => {
		return async (
			dispatch: Dispatch,
			getState: () => ProposalBuilderState
		): Promise<DeleteBlockSuccessfulAction> => {
			try {
				const deleteBlockRequestedAction: DeleteBlockRequestedAction = {
					type: BlocksActionTypes.DELETE_BLOCK_REQUESTED
				};
				dispatch(deleteBlockRequestedAction);

				const currentActiveBlock =
					getState().blocks.currentActiveBlock[0];
				const isFocused =
					currentActiveBlock && blockIds.includes(currentActiveBlock);
				if (isFocused) {
					// updating the focus
					const resetBlockFocusAction: ResetBlockFocusAction = {
						type: BlocksActionTypes.RESET_BLOCK_FOCUS
					};
					dispatch(resetBlockFocusAction);
				}

				const updatedBlockMapper: BlockMapper = Object.entries(
					getState().blocks.blockMapper
				).reduce((final, [blockId, block]) => {
					if (!blockIds.includes(blockId)) {
						final = {
							...final,
							[blockId]: block
						};
					}

					return final;
				}, {});
				// delete updatedBlockMapper[blockIds];

				// updating the state
				const deleteBlockSuccessfulAction: DeleteBlockSuccessfulAction =
					{
						type: BlocksActionTypes.DELETE_BLOCK_SUCCESSFUL,
						blockMapper: updatedBlockMapper
					};

				return dispatch(deleteBlockSuccessfulAction);
			} catch (error) {
				console.error(error);

				const deleteBlockFailedAction: DeleteBlockFailedAction = {
					type: BlocksActionTypes.DELETE_BLOCK_FAILED
				};
				dispatch(deleteBlockFailedAction);

				throw Promise.reject(error);
			}
		};
	},
	hideBlock: ({ blockId }: { blockId: string }) => {
		return async (
			dispatch: Dispatch,
			getState: () => ProposalBuilderState
		): Promise<HideBlockSuccessfulAction> => {
			try {
				const hideBlockRequestedAction: HideBlockRequestedAction = {
					type: BlocksActionTypes.HIDE_BLOCK_REQUESTED
				};
				dispatch(hideBlockRequestedAction);

				const blockToHide = cloneDeep(
					getState().blocks.blockMapper[blockId]
				);
				const newBlock = { ...blockToHide, hide: true };
				editBlock(newBlock);

				// updating the state
				const hideBlockSuccessfulAction: HideBlockSuccessfulAction = {
					type: BlocksActionTypes.HIDE_BLOCK_SUCCESSFUL,
					blockData: newBlock
				};

				return dispatch(hideBlockSuccessfulAction);
			} catch (error) {
				console.error(error);

				const hideBlockFailedAction: HideBlockFailedAction = {
					type: BlocksActionTypes.HIDE_BLOCK_FAILED
				};
				dispatch(hideBlockFailedAction);

				throw Promise.reject(error);
			}
		};
	},
	unhideBlock: ({ blockId }: { blockId: string }) => {
		return async (
			dispatch: Dispatch,
			getState: () => ProposalBuilderState
		): Promise<UnhideBlockSuccessfulAction> => {
			try {
				const unhideBlockRequestedAction: UnhideBlockRequestedAction = {
					type: BlocksActionTypes.UNHIDE_BLOCK_REQUESTED
				};
				dispatch(unhideBlockRequestedAction);

				const blockToUnhide = cloneDeep(
					getState().blocks.blockMapper[blockId]
				);
				const newBlock = { ...blockToUnhide, hide: false };
				editBlock(newBlock);

				// updating the state
				const unhideBlockSuccessfulAction: UnhideBlockSuccessfulAction =
					{
						type: BlocksActionTypes.UNHIDE_BLOCK_SUCCESSFUL,
						blockData: newBlock
					};

				return dispatch(unhideBlockSuccessfulAction);
			} catch (error) {
				console.error(error);

				const unhideBlockFailedAction: UnhideBlockFailedAction = {
					type: BlocksActionTypes.UNHIDE_BLOCK_FAILED
				};
				dispatch(unhideBlockFailedAction);

				throw Promise.reject(error);
			}
		};
	},

	showQuickbooksTooltip: () => {
		return (dispatch: Dispatch): QuickbooksTooltipShowAction => {
			const QuickbooksTooltipShowAction: QuickbooksTooltipShowAction = {
				type: BlocksActionTypes.QUICKBOOKS_SYNC_TOOLTIP_SHOW
			};
			return dispatch(QuickbooksTooltipShowAction);
		};
	},
	hideQuickbooksTooltip: () => {
		return (dispatch: Dispatch): QuickbooksTooltipHideAction => {
			const QuickbooksTooltipHideAction: QuickbooksTooltipHideAction = {
				type: BlocksActionTypes.QUICKBOOKS_SYNC_TOOLTIP_HIDE
			};
			return dispatch(QuickbooksTooltipHideAction);
		};
	},

	updateBlock: (block: Block) => {
		return async (
			dispatch: Dispatch,
			getState: () => ProposalBuilderState
		): Promise<UpdateBlockSuccessfulAction> => {
			const updateBlockRequestedAction: UpdateBlockRequestedAction = {
				type: BlocksActionTypes.UPDATE_BLOCK_REQUESTED
			};
			dispatch(updateBlockRequestedAction);

			const parentState = getState().parentState;
			const mergeTagsFromDocument =
				parentState.currentActiveDocument?.merge_tag_system_variables;

			const mergeTagsFromTemplate =
				parentState.currentActiveTemplate?.merge_tags_system_variables;

			const mergeTags = mergeTagsFromDocument || mergeTagsFromTemplate;

			const document = parentState.currentActiveDocument as Document;
			const taxRegions = parentState.taxRegionsList;
			const taxCategories = parentState.taxCategoriesList;

			if (block.type === BlockType.QUOTE) {
				const newData = block.data as QuoteBlockData;
				newData.tax = calculateTax(
					newData,
					document,
					taxRegions,
					taxCategories
				)?.tax;
				newData.total = calculateGrandTotal(
					newData,
					document,
					taxRegions,
					taxCategories
				);
				block.data = newData;
			}

			try {
				// making http calls
				const editBlockRequest = {
					...block,
					data: {
						...block.data
					}
				};

				if (
					editBlockRequest.data &&
					editBlockRequest.type === BlockType.TEXT &&
					mergeTags
				) {
					const text = (editBlockRequest.data as TextBlockData).text;
					const newText = replaceMergeTagsWithId(mergeTags, text);
					const newData = {
						...(editBlockRequest.data as TextBlockData)
					};
					newData.text = newText;
					editBlockRequest.data = newData;
				}
				let payload = block;
				let paymentSummary: PaymentSummary | null = null;

				if (editBlockRequest.type === BlockType.QUOTE) {
					const response = await editQuoteBlock(editBlockRequest);
					const { payment_summary, ...blockData } = response;
					payload = { ...blockData };
					paymentSummary = payment_summary
						? { ...payment_summary }
						: null;
				} else editBlock(editBlockRequest);

				// updating the state
				const updateBlockSuccessfulAction: UpdateBlockSuccessfulAction =
					{
						type: BlocksActionTypes.UPDATE_BLOCK_SUCCESSFUL,
						blockData: payload,
						isQuoteBlock: editBlockRequest.type === BlockType.QUOTE
					};

				// const updateCurrentDocPaymentSummarySuccessfulAction: UpdateCurrentDocPaymentSummarySuccessfulAction =
				// 	{
				// 		type: DocumentsActionTypes.UPDATE_CURRENT_DOC_PAYMENT_SUMMARY_SUCCESSFUL,
				// 		paymentSummary
				// 	};
				// dispatch(updateCurrentDocPaymentSummarySuccessfulAction);
				dispatch({
					type: ParentStateActionTypes.UPDATE_CURRENT_DOC_PAYMENT_SUMMARY_SUCCESSFUL,
					paymentSummary
				});
				return dispatch(updateBlockSuccessfulAction);
			} catch (error) {
				console.error(error);
				const updateBlockFailedAction: UpdateBlockFailedAction = {
					type: BlocksActionTypes.UPDATE_BLOCK_FAILED
				};
				dispatch(updateBlockFailedAction);

				return Promise.reject(error);
			}
		};
	},
	updateBlockFromClient: (block: Block) => {
		return async (
			dispatch: Dispatch,
			getState: () => ProposalBuilderState
		): Promise<UpdateBlockSuccessfulAction> => {
			const updateBlockRequestedAction: UpdateBlockRequestedAction = {
				type: BlocksActionTypes.UPDATE_BLOCK_REQUESTED
			};
			dispatch(updateBlockRequestedAction);

			const parentState = getState().parentState;
			const document = parentState.currentActiveDocument as Document;
			const taxRegions = parentState.taxRegionsList;
			const taxCategories = parentState.taxCategoriesList;

			if (block.type === BlockType.QUOTE) {
				const newData = cloneDeep(block.data as QuoteBlockData);
				newData.tax = calculateTax(
					newData,
					document,
					taxRegions,
					taxCategories
				)?.tax;
				newData.total = calculateGrandTotal(
					newData,
					document,
					taxRegions,
					taxCategories
				);
				block.data = newData;
			}

			try {
				const isGenericOrderForm =
					document?.document_type === DocumentType.GENERIC_ORDER_FORM;

				// making http calls
				const response = isGenericOrderForm
					? await editBlockFromPublicClient(
							block,
							document?.company_id
					  )
					: await editBlockFromClient(block);
				const { payment_summary: paymentSummary, ...blockData } =
					response;

				// handling gof block changes
				const isClientUser =
					getQueryParamAuthDetails()?.queryParam?.includes(
						QueryParamConstants.CLIENT_USER_ID
					);

				if (isGenericOrderForm && document && isClientUser) {
					blockData.updated = block.updated;
					setGOFBlockData(document, blockData);
					const blockList = getGOFDocumentData(document.id);
					const request = new GOFPaymentSummaryRequestData();
					request.blocks_metadata_gof = blockList?.blocks ?? [];
					const response = await calculatePaymentSummary(
						request,
						document.company_id
					);
					setGOFPaymentData(document.id, response);
					if (document?.payment) {
						dispatch({
							type: ParentStateActionTypes.UPDATE_CURRENT_ACTIVE_DOCUMENT,
							currentActiveDocument: {
								...document,
								payment: response
							}
						});
					}
				}
				// updating the state
				const updateBlockSuccessfulAction: UpdateBlockSuccessfulAction =
					{
						type: BlocksActionTypes.UPDATE_BLOCK_SUCCESSFUL,
						blockData,
						isQuoteBlock: block.type === BlockType.QUOTE
					};

				// const updateCurrentDocPaymentSummarySuccessfulAction: UpdateCurrentDocPaymentSummarySuccessfulAction =
				// 	{
				// 		type: DocumentsActionTypes.UPDATE_CURRENT_DOC_PAYMENT_SUMMARY_SUCCESSFUL,
				// 		paymentSummary
				// 	};
				// dispatch(updateCurrentDocPaymentSummarySuccessfulAction);
				dispatch({
					type: ParentStateActionTypes.UPDATE_CURRENT_DOC_PAYMENT_SUMMARY_SUCCESSFUL,
					paymentSummary
				});
				return dispatch(updateBlockSuccessfulAction);
			} catch (error) {
				console.error(error);
				const updateBlockFailedAction: UpdateBlockFailedAction = {
					type: BlocksActionTypes.UPDATE_BLOCK_FAILED
				};
				dispatch(updateBlockFailedAction);

				return Promise.reject(error);
			}
		};
	},
	updateBlockData: ({
		blockData,
		blockId
	}: {
		blockData: Partial<BlockData>;
		blockId: string;
	}) => {
		return async (
			dispatch: Dispatch,
			getState: () => ProposalBuilderState
		): Promise<UpdateBlockSuccessfulAction> => {
			const updateBlockRequestedAction: UpdateBlockRequestedAction = {
				type: BlocksActionTypes.UPDATE_BLOCK_REQUESTED
			};
			dispatch(updateBlockRequestedAction);

			const state = getState();
			const selectedBlock = cloneDeep(state.blocks.blockMapper[blockId]);

			const updatedQuoteBlockLoaders = [
				...state.blocks.loadingQuoteBlockIds,
				blockId
			];

			const showQuoteBlockLoaderAction: UpdateQuoteBlockLoaderIdsAction =
				{
					type: BlocksActionTypes.UPDATE_QUOTE_BLOCK_LOADER_IDS,
					quoteBlockIds: updatedQuoteBlockLoaders
				};

			dispatch(showQuoteBlockLoaderAction);

			/* 	
				TODO: Just a simple spread operator is NOT enough -> This needs to be a nested spread operator so that functions
				can pass tiny slices of nested sub-objects to be updated instead of having
				the burden to correctly pass the entire sub-object
			*/
			// Deep merge blockData to handle nested objects properly
			let mergedData = {
				...selectedBlock.data,
				...blockData
			};

			// Special handling for pricing_table_styles to ensure deep merge
			if (
				selectedBlock.type === BlockType.QUOTE &&
				"pricing_table_styles" in blockData
			) {
				const existingStyles = (selectedBlock.data as QuoteBlockData)
					?.pricing_table_styles;
				const newStyles = (blockData as Partial<QuoteBlockData>)
					?.pricing_table_styles;

				if (existingStyles && newStyles) {
					mergedData = {
						...mergedData,
						pricing_table_styles: {
							font: newStyles.font ?? existingStyles.font,
							pricing_table_theme: {
								font_color:
									newStyles.pricing_table_theme?.font_color ??
									existingStyles.pricing_table_theme
										?.font_color,
								background_color:
									newStyles.pricing_table_theme
										?.background_color ??
									existingStyles.pricing_table_theme
										?.background_color,
								theme_choice:
									newStyles.pricing_table_theme
										?.theme_choice ??
									existingStyles.pricing_table_theme
										?.theme_choice
							}
						}
					};
				}
			}

			const newBlock = {
				...selectedBlock,
				data: mergedData
			};

			if (newBlock.type === BlockType.QUOTE) {
				const newData = newBlock.data as QuoteBlockData;
				newBlock.data = newData;
			}

			const mergeTagsFromDocument =
				state.parentState.currentActiveDocument
					?.merge_tag_system_variables;

			const mergeTagsFromTemplate =
				state.parentState.currentActiveTemplate
					?.merge_tags_system_variables;

			const mergeTags = mergeTagsFromDocument || mergeTagsFromTemplate;

			try {
				// making http calls
				const editBlockRequest = {
					...newBlock,
					data: {
						...newBlock.data
					}
				};

				if (
					editBlockRequest.data &&
					editBlockRequest.type === BlockType.TEXT &&
					mergeTags
				) {
					const text = (editBlockRequest.data as TextBlockData).text;
					const newText = replaceMergeTagsWithId(mergeTags, text);
					const newData = {
						...(editBlockRequest.data as TextBlockData)
					};
					newData.text = newText;
					editBlockRequest.data = newData;
				}

				const updatedBlockData = await editBlock(editBlockRequest);
				const { payment_summary: paymentSummary, ...blockData } =
					updatedBlockData;
				// updating the state
				const updateBlockSuccessfulAction: UpdateBlockSuccessfulAction =
					{
						type: BlocksActionTypes.UPDATE_BLOCK_SUCCESSFUL,
						blockData
					};
				// const updateCurrentDocPaymentSummarySuccessfulAction: UpdateCurrentDocPaymentSummarySuccessfulAction =
				// 	{
				// 		type: DocumentsActionTypes.UPDATE_CURRENT_DOC_PAYMENT_SUMMARY_SUCCESSFUL,
				// 		paymentSummary
				// 	};
				// dispatch(updateCurrentDocPaymentSummarySuccessfulAction);
				dispatch({
					type: ParentStateActionTypes.UPDATE_CURRENT_DOC_PAYMENT_SUMMARY_SUCCESSFUL,
					paymentSummary
				});

				const hideQuoteBlockLoaderAction: UpdateQuoteBlockLoaderIdsAction =
					{
						type: BlocksActionTypes.UPDATE_QUOTE_BLOCK_LOADER_IDS,
						quoteBlockIds: updatedQuoteBlockLoaders.filter(
							id => id !== blockId
						)
					};

				dispatch(hideQuoteBlockLoaderAction);

				return dispatch(updateBlockSuccessfulAction);
			} catch (error) {
				console.error(error);
				const updateBlockFailedAction: UpdateBlockFailedAction = {
					type: BlocksActionTypes.UPDATE_BLOCK_FAILED
				};
				const hideQuoteBlockLoaderAction: UpdateQuoteBlockLoaderIdsAction =
					{
						type: BlocksActionTypes.UPDATE_QUOTE_BLOCK_LOADER_IDS,
						quoteBlockIds: updatedQuoteBlockLoaders.filter(
							id => id !== blockId
						)
					};

				dispatch(hideQuoteBlockLoaderAction);
				dispatch(updateBlockFailedAction);
				return Promise.reject(error);
			}
		};
	},
	updateBlockFocus: (blockId: string) => {
		return (
			dispatch: Dispatch,
			getState: () => ProposalBuilderState
		): UpdateBlockFocusAction => {
			const updateBlockFocusAction: UpdateBlockFocusAction = {
				type: BlocksActionTypes.UPDATE_BLOCK_FOCUS,
				currentActiveBlock: [blockId]
			};
			const currentFocusedBlock = getState().blocks.blockMapper[blockId];
			if (
				currentFocusedBlock &&
				currentFocusedBlock.type === BlockType.TEXT &&
				window.tinyMCE &&
				window.tinyMCE &&
				window.tinyMCE.EditorManager &&
				window.tinyMCE.EditorManager.get(blockId)
			) {
				window.tinyMCE.EditorManager.get(blockId).focus();
			}
			return dispatch(updateBlockFocusAction);
		};
	},
	updateChildFocus:
		({ parentId, childId }: { parentId: string; childId: string }) =>
		(
			dispatch: Dispatch,
			getState: () => ProposalBuilderState
		): UpdateBlockFocusAction => {
			const prevParentBlockId = getState().blocks.currentActiveBlock[0];
			const currentFocusedBlockId = childId ? childId : parentId;
			const currentFocusedBlock =
				getState().blocks.blockMapper[currentFocusedBlockId];
			if (
				currentFocusedBlock &&
				currentFocusedBlock.type === BlockType.TEXT &&
				window.tinyMCE &&
				window.tinyMCE &&
				window.tinyMCE.EditorManager &&
				window.tinyMCE.EditorManager.get(currentFocusedBlockId)
			) {
				window.tinyMCE.EditorManager.get(currentFocusedBlockId).focus();
			}
			const updateBlockFocusAction: UpdateBlockFocusAction = {
				type: BlocksActionTypes.UPDATE_BLOCK_FOCUS,
				currentActiveBlock: [parentId || prevParentBlockId, childId]
			};
			return dispatch(updateBlockFocusAction);
		},
	resetBlockFocus:
		() =>
		(dispatch: Dispatch): ResetBlockFocusAction => {
			const resetBlockFocusAction: ResetBlockFocusAction = {
				type: BlocksActionTypes.RESET_BLOCK_FOCUS
			};
			return dispatch(resetBlockFocusAction);
		},
	// QuoteBlock
	updateSectionFocus: (sectionIndex: number) => {
		return (dispatch: Dispatch): UpdateSectionFocusAction => {
			const updateSectionFocusAction: UpdateSectionFocusAction = {
				type: BlocksActionTypes.UPDATE_SECTION_FOCUS,
				currentActiveSection: sectionIndex
			};
			return dispatch(updateSectionFocusAction);
		};
	},
	repositionProductsInQuoteBlock: ({
		blockId,
		sectionIndex,
		sourceIndex,
		destIndex
	}) => {
		return async (
			dispatch: Dispatch,
			getState: () => ProposalBuilderState
		): Promise<UpdateBlockSuccessfulAction> => {
			try {
				const updateBlockRequestedAction: UpdateBlockRequestedAction = {
					type: BlocksActionTypes.UPDATE_BLOCK_REQUESTED
				};
				dispatch(updateBlockRequestedAction);
				// get block data
				let block: Block = cloneDeep(
					getState().blocks.blockMapper[blockId]
				);
				const blockData = block.data as QuoteBlockData;
				// target the section array
				const newSection = [...blockData.sections];
				const selectedSection = newSection[sectionIndex];
				// update the reposition
				selectedSection.products.splice(
					destIndex,
					0,
					selectedSection.products.splice(sourceIndex, 1)[0]
				);
				// merge it back to the block
				block = {
					...block,
					data: {
						...blockData,
						section: newSection
					}
				};
				// call the update service
				editBlock(block)
					.then(response => {
						const updateBlockSuccessfulAction: UpdateBlockSuccessfulAction =
							{
								type: BlocksActionTypes.UPDATE_BLOCK_SUCCESSFUL,
								blockData: response
							};
						return dispatch(updateBlockSuccessfulAction);
					})
					.catch(err => console.error(err));

				// update the redux store
				const updateBlockSuccessfulAction: UpdateBlockSuccessfulAction =
					{
						type: BlocksActionTypes.UPDATE_BLOCK_SUCCESSFUL,
						blockData: block
					};

				const updateSectionFocusAction: UpdateSectionFocusAction = {
					type: BlocksActionTypes.UPDATE_SECTION_FOCUS,
					currentActiveSection: sectionIndex
				};
				dispatch(updateSectionFocusAction);

				return dispatch(updateBlockSuccessfulAction);
			} catch (error) {
				console.error(error);
				const updateBlockFailedAction: UpdateBlockFailedAction = {
					type: BlocksActionTypes.UPDATE_BLOCK_FAILED
				};
				dispatch(updateBlockFailedAction);
				throw error;
			}
		};
	},
	repositionSectionsInQuoteBlock: ({ blockId, sourceIndex, destIndex }) => {
		return (
			dispatch: Dispatch,
			getState: () => ProposalBuilderState
		): UpdateBlockSuccessfulAction => {
			try {
				const updateBlockRequestedAction: UpdateBlockRequestedAction = {
					type: BlocksActionTypes.UPDATE_BLOCK_REQUESTED
				};
				dispatch(updateBlockRequestedAction);

				let block: Block = cloneDeep(
					getState().blocks.blockMapper[blockId]
				);
				const blockData = block.data as QuoteBlockData;

				const newSection = [...blockData.sections];

				const [removed] = newSection.splice(sourceIndex, 1);
				const normalizedDestIndex =
					sourceIndex < destIndex ? destIndex - 1 : destIndex;

				newSection.splice(normalizedDestIndex, 0, removed);

				block = {
					...block,
					data: {
						...blockData,
						sections: newSection
					}
				};

				// call the update service
				editBlock(block)
					.then(response => {
						const updateBlockSuccessfulAction: UpdateBlockSuccessfulAction =
							{
								type: BlocksActionTypes.UPDATE_BLOCK_SUCCESSFUL,
								blockData: response
							};
						return dispatch(updateBlockSuccessfulAction);
					})
					.catch(err => console.error(err));

				const updateBlockSuccessfulAction: UpdateBlockSuccessfulAction =
					{
						type: BlocksActionTypes.UPDATE_BLOCK_SUCCESSFUL,
						blockData: block
					};

				const updateSectionFocusAction: UpdateSectionFocusAction = {
					type: BlocksActionTypes.UPDATE_SECTION_FOCUS,
					currentActiveSection: normalizedDestIndex
				};
				dispatch(updateSectionFocusAction);

				return dispatch(updateBlockSuccessfulAction);
			} catch (error) {
				console.error(error);
				const updateBlockFailedAction: UpdateBlockFailedAction = {
					type: BlocksActionTypes.UPDATE_BLOCK_FAILED
				};
				dispatch(updateBlockFailedAction);
				throw error;
			}
		};
	},
	repositionProductsAcrossSectionsInQuoteBlock: ({
		blockId,
		productId,
		sourceSectionIndex,
		destSectionIndex,
		sourceIndex,
		destIndex
	}) => {
		return async (
			dispatch: Dispatch,
			getState: () => ProposalBuilderState
		): Promise<UpdateBlockSuccessfulAction> => {
			try {
				const updateBlockRequestedAction: UpdateBlockRequestedAction = {
					type: BlocksActionTypes.UPDATE_BLOCK_REQUESTED
				};
				dispatch(updateBlockRequestedAction);
				// get block data
				let block: Block = cloneDeep(
					getState().blocks.blockMapper[blockId]
				);
				const blockData = block.data as QuoteBlockData;

				const newSections = [...blockData.sections];

				// ------------------ removing the product from the source section -----------------------

				newSections[sourceSectionIndex].selected_products = [
					...newSections[sourceSectionIndex].selected_products.filter(
						pID => pID !== productId
					)
				];

				const movingProduct = newSections[
					sourceSectionIndex
				].products.splice(sourceIndex, 1);

				// ------------------ adding the product to the destination section -----------------------

				newSections[destSectionIndex].selected_products = [
					...(newSections[destSectionIndex].selected_products ?? [])
				];
				newSections[destSectionIndex].selected_products.splice(
					destIndex,
					0,
					productId
				);

				newSections[destSectionIndex].products.splice(
					destIndex,
					0,
					movingProduct[0]
				);

				// merge it back to the block

				block = {
					...block,
					data: {
						...blockData,
						sections: newSections
					}
				};
				// call the update service
				editBlock(block)
					.then(response => {
						const updateBlockSuccessfulAction: UpdateBlockSuccessfulAction =
							{
								type: BlocksActionTypes.UPDATE_BLOCK_SUCCESSFUL,
								blockData: response
							};
						return dispatch(updateBlockSuccessfulAction);
					})
					.catch(err => console.error(err));

				// update the redux store
				const updateBlockSuccessfulAction: UpdateBlockSuccessfulAction =
					{
						type: BlocksActionTypes.UPDATE_BLOCK_SUCCESSFUL,
						blockData: block
					};

				const updateSectionFocusAction: UpdateSectionFocusAction = {
					type: BlocksActionTypes.UPDATE_SECTION_FOCUS,
					currentActiveSection: destSectionIndex
				};
				dispatch(updateSectionFocusAction);

				return dispatch(updateBlockSuccessfulAction);
			} catch (error) {
				console.error(error);
				const updateBlockFailedAction: UpdateBlockFailedAction = {
					type: BlocksActionTypes.UPDATE_BLOCK_FAILED
				};
				dispatch(updateBlockFailedAction);
				throw error;
			}
		};
	},
	updateProductDetails:
		({
			blockId,
			sectionIndex,
			quoteProductId,
			data,
			isFromUser,
			updateChild,
			setAsGlobal,
			setupFeeLabel
		}: {
			blockId: string;
			sectionIndex: number;
			quoteProductId: string;
			data: Partial<QuoteProduct>;
			isFromUser: boolean;
			updateChild?: boolean;
			setAsGlobal?: boolean;
			setupFeeLabel?: string;
		}) =>
		async (
			dispatch: Dispatch,
			getState: () => ProposalBuilderState
		): Promise<UpdateBlockSuccessfulAction> => {
			const state = getState();
			const selectedBlock = cloneDeep(state.blocks.blockMapper[blockId]);
			const existingQuoteBlockLoaders = [
				...state.blocks.loadingQuoteBlockIds,
				selectedBlock.id
			];

			try {
				// show the loader
				const showBlockLoaderAction: ShowBlockLoaderAction = {
					type: BlocksActionTypes.SHOW_BLOCK_LOADER
				};
				dispatch(showBlockLoaderAction);

				const updateBlockRequestedAction: UpdateBlockRequestedAction = {
					type: BlocksActionTypes.UPDATE_BLOCK_REQUESTED
				};
				dispatch(updateBlockRequestedAction);

				const blockData = { ...(selectedBlock.data as QuoteBlockData) };
				const sectionData = { ...blockData.sections[sectionIndex] };
				const productLists = [...sectionData.products];

				const showQuoteBlockLoaderAction: UpdateQuoteBlockLoaderIdsAction =
					{
						type: BlocksActionTypes.UPDATE_QUOTE_BLOCK_LOADER_IDS,
						quoteBlockIds: existingQuoteBlockLoaders
					};

				dispatch(showQuoteBlockLoaderAction);

				const updateProductList = productLists.map<QuoteProduct>(
					product => {
						if (product.id === quoteProductId) {
							const bundleProducts =
								product.bundled_products?.map(childProduct => {
									if (
										product.product_type ===
											ProductType.Bundle &&
										updateChild
									) {
										return {
											...childProduct,
											...data
										};
									} else return { ...childProduct };
								});

							const bundleProductsSku = product.bundled_skus?.map(
								childProduct => {
									if (
										product.product_type ===
											ProductType.Bundle &&
										updateChild
									) {
										return {
											...childProduct,
											...data
										};
									} else return { ...childProduct };
								}
							);

							return {
								...product,
								bundled_products: bundleProducts,
								bundled_skus: bundleProductsSku,
								...data
							};
						} else return product;
					}
				);

				// update the block
				sectionData.products = updateProductList;

				const updatedSections = (
					selectedBlock.data as QuoteBlockData
				).sections.map((section, index) =>
					index === sectionIndex ? { ...sectionData } : { ...section }
				);

				selectedBlock.data = {
					...selectedBlock.data,
					sections: [...updatedSections],
					additional_setup_price_consistent: setAsGlobal,
					label: {
						...DefaultQuoteLabels,
						...blockData.label,
						additional_setup_price_label: setAsGlobal
							? setupFeeLabel
							: blockData?.label?.additional_setup_price_label
					}
				};
				const currentActiveDocument =
					state.parentState.currentActiveDocument;

				const isGenericOrderForm =
					currentActiveDocument?.document_type ===
					DocumentType.GENERIC_ORDER_FORM;

				const response: BlockResponse = !!isFromUser
					? await editBlock(selectedBlock)
					: isGenericOrderForm
					? await editBlockFromPublicClient(
							selectedBlock,
							currentActiveDocument?.company_id
					  )
					: await editBlockFromClient(selectedBlock);
				const { payment_summary: paymentSummary, ...updatedBlock } =
					response;

				// handling gof block changes
				const isClientUser =
					getQueryParamAuthDetails()?.queryParam?.includes(
						QueryParamConstants.CLIENT_USER_ID
					);

				if (
					isGenericOrderForm &&
					currentActiveDocument &&
					isClientUser
				) {
					updatedBlock.updated = selectedBlock.updated;
					setGOFBlockData(currentActiveDocument, updatedBlock);
					const blockList = getGOFDocumentData(
						currentActiveDocument?.id
					);
					const request = new GOFPaymentSummaryRequestData();
					request.blocks_metadata_gof = blockList?.blocks ?? [];
					const response = await calculatePaymentSummary(
						request,
						currentActiveDocument?.company_id
					);
					setGOFPaymentData(currentActiveDocument?.id, response);

					if (currentActiveDocument?.payment) {
						dispatch({
							type: ParentStateActionTypes.UPDATE_CURRENT_ACTIVE_DOCUMENT,
							currentActiveDocument: {
								...currentActiveDocument,
								payment: response
							}
						});
					}
				}
				// hide loader
				const hideBlockLoaderAction: HideBlockLoaderAction = {
					type: BlocksActionTypes.HIDE_BLOCK_LOADER
				};
				dispatch(hideBlockLoaderAction);

				// updating to the state
				const updateBlockSuccessfulAction: UpdateBlockSuccessfulAction =
					{
						type: BlocksActionTypes.UPDATE_BLOCK_SUCCESSFUL,
						blockData: updatedBlock,
						isQuoteBlock: true
					};

				const hideQuoteBlockLoaderAction: UpdateQuoteBlockLoaderIdsAction =
					{
						type: BlocksActionTypes.UPDATE_QUOTE_BLOCK_LOADER_IDS,
						quoteBlockIds: existingQuoteBlockLoaders.filter(
							id => id !== selectedBlock.id
						)
					};

				dispatch(hideQuoteBlockLoaderAction);

				// const updateCurrentDocPaymentSummarySuccessfulAction: UpdateCurrentDocPaymentSummarySuccessfulAction =
				// 	{
				// 		type: DocumentsActionTypes.UPDATE_CURRENT_DOC_PAYMENT_SUMMARY_SUCCESSFUL,
				// 		paymentSummary
				// 	};
				// dispatch(updateCurrentDocPaymentSummarySuccessfulAction);
				dispatch({
					type: ParentStateActionTypes.UPDATE_CURRENT_DOC_PAYMENT_SUMMARY_SUCCESSFUL,
					paymentSummary
				});

				return dispatch(updateBlockSuccessfulAction);
			} catch (error) {
				console.error(error);

				const hideQuoteBlockLoaderAction: UpdateQuoteBlockLoaderIdsAction =
					{
						type: BlocksActionTypes.UPDATE_QUOTE_BLOCK_LOADER_IDS,
						quoteBlockIds: existingQuoteBlockLoaders.filter(
							id => id !== selectedBlock.id
						)
					};

				dispatch(hideQuoteBlockLoaderAction);

				const hideBlockLoaderAction: HideBlockLoaderAction = {
					type: BlocksActionTypes.HIDE_BLOCK_LOADER
				};
				dispatch(hideBlockLoaderAction);
				const updateBlockFailedAction: UpdateBlockFailedAction = {
					type: BlocksActionTypes.UPDATE_BLOCK_FAILED
				};
				dispatch(updateBlockFailedAction);
				return Promise.reject(error);
			}
		},
	editProductInQuoteBlockSectionFromDrawer:
		({ blockId, sectionIndex, quoteProductId, data }) =>
		async (
			dispatch: Dispatch,
			getState: () => ProposalBuilderState
		): Promise<UpdateBlockSuccessfulAction> => {
			try {
				// show the loader
				const showBlockLoaderAction: ShowBlockLoaderAction = {
					type: BlocksActionTypes.SHOW_BLOCK_LOADER
				};
				dispatch(showBlockLoaderAction);
				const updateBlockRequestedAction: UpdateBlockRequestedAction = {
					type: BlocksActionTypes.UPDATE_BLOCK_REQUESTED
				};
				dispatch(updateBlockRequestedAction);

				const state = getState();

				const selectedBlock = cloneDeep(
					state.blocks.blockMapper[blockId]
				);
				const blockData = selectedBlock.data as QuoteBlockData;
				const sectionData = { ...blockData.sections[sectionIndex] };
				const productLists = [...sectionData.products];
				// find index of the product
				const productIndex = productLists.findIndex(
					p => p.id === quoteProductId
				);
				if (productIndex === -1) {
					throw new Error(
						`Update Aborted, reason: didn't find product`
					);
				}

				const {
					discount,
					discount_type,
					discount_percentage,
					selected_setup_discount,
					setup_discount_percentage,
					setup_discount_type
				} = productLists[productIndex];

				// mutating product data
				productLists[productIndex] = {
					...productLists[productIndex],
					...data,
					discount_type: discount_type,
					discount: discount,
					discount_percentage: discount_percentage,
					selected_setup_discount: selected_setup_discount,
					setup_discount_percentage: setup_discount_percentage,
					setup_discount_type: setup_discount_type
				};

				// update the block
				sectionData.products = productLists;

				// clone and assign to prevent read-only error
				const sections = [...blockData.sections];
				sections[sectionIndex] = sectionData;
				selectedBlock.data = {
					...blockData,
					sections
				};

				const blockResponse = await editBlock(selectedBlock);
				const { payment_summary: paymentSummary, ...updatedBlock } =
					blockResponse;
				// hide loader
				const hideBlockLoaderAction: HideBlockLoaderAction = {
					type: BlocksActionTypes.HIDE_BLOCK_LOADER
				};
				dispatch(hideBlockLoaderAction);

				// updating to the state
				const updateBlockSuccessfulAction: UpdateBlockSuccessfulAction =
					{
						type: BlocksActionTypes.UPDATE_BLOCK_SUCCESSFUL,
						blockData: updatedBlock,
						isQuoteBlock: true
					};
				// const updateCurrentDocPaymentSummarySuccessfulAction: UpdateCurrentDocPaymentSummarySuccessfulAction =
				// 	{
				// 		type: DocumentsActionTypes.UPDATE_CURRENT_DOC_PAYMENT_SUMMARY_SUCCESSFUL,
				// 		paymentSummary
				// 	};
				// dispatch(updateCurrentDocPaymentSummarySuccessfulAction);
				dispatch({
					type: ParentStateActionTypes.UPDATE_CURRENT_DOC_PAYMENT_SUMMARY_SUCCESSFUL,
					paymentSummary
				});
				return dispatch(updateBlockSuccessfulAction);
			} catch (error) {
				console.error(error);

				const hideBlockLoaderAction: HideBlockLoaderAction = {
					type: BlocksActionTypes.HIDE_BLOCK_LOADER
				};
				dispatch(hideBlockLoaderAction);
				const updateBlockFailedAction: UpdateBlockFailedAction = {
					type: BlocksActionTypes.UPDATE_BLOCK_FAILED
				};
				dispatch(updateBlockFailedAction);
				return Promise.reject(error);
			}
		},
	addProductInQuoteBlockSection:
		({
			blockId,
			sectionIndex,
			quoteProductFormValues,
			productPosition
		}: AddProductToQuoteBlockArgs) =>
		async (
			dispatch: Dispatch,
			getState: () => ProposalBuilderState
		): Promise<UpdateBlockSuccessfulAction> => {
			const state = getState();
			const selectedBlock = cloneDeep(state.blocks.blockMapper[blockId]);

			try {
				// show the loader
				const showBlockLoaderAction: ShowBlockLoaderAction = {
					type: BlocksActionTypes.SHOW_BLOCK_LOADER
				};
				dispatch(showBlockLoaderAction);
				const updateBlockRequestedAction: UpdateBlockRequestedAction = {
					type: BlocksActionTypes.UPDATE_BLOCK_REQUESTED
				};
				dispatch(updateBlockRequestedAction);

				const blockData = { ...(selectedBlock.data as QuoteBlockData) };
				const sectionData = { ...blockData.sections[sectionIndex] };
				let productLists = [...sectionData.products];

				// create QuoteProduct from Product data
				const quoteProduct = new AddQuoteProductCatalogDrawerFormValues(
					{
						...quoteProductFormValues
					}
				) as QuoteProduct;

				// mutations on the block data
				if (productPosition) {
					productLists = [...productLists];
					productLists.splice(productPosition, 0, {
						...quoteProduct
					});
				} else {
					productLists = [...productLists, { ...quoteProduct }];
				}

				// update the block
				sectionData.products = productLists;

				const updatedSections = (
					selectedBlock.data as QuoteBlockData
				).sections.map((section, index) =>
					index === sectionIndex ? { ...sectionData } : { ...section }
				);

				selectedBlock.data = {
					...selectedBlock.data,
					sections: [...updatedSections]
				};
				const updatedBlockResponse = await editBlock(selectedBlock);
				const { payment_summary: paymentSummary, ...updatedBlock } =
					updatedBlockResponse;
				// hide loader
				const hideBlockLoaderAction: HideBlockLoaderAction = {
					type: BlocksActionTypes.HIDE_BLOCK_LOADER
				};
				dispatch(hideBlockLoaderAction);

				// updating to the state
				const updateBlockSuccessfulAction: UpdateBlockSuccessfulAction =
					{
						type: BlocksActionTypes.UPDATE_BLOCK_SUCCESSFUL,
						blockData: updatedBlock,
						isQuoteBlock: true
					};

				// const updateCurrentDocPaymentSummarySuccessfulAction: UpdateCurrentDocPaymentSummarySuccessfulAction =
				// 	{
				// 		type: DocumentsActionTypes.UPDATE_CURRENT_DOC_PAYMENT_SUMMARY_SUCCESSFUL,
				// 		paymentSummary
				// 	};
				// dispatch(updateCurrentDocPaymentSummarySuccessfulAction);
				dispatch({
					type: ParentStateActionTypes.UPDATE_CURRENT_DOC_PAYMENT_SUMMARY_SUCCESSFUL,
					paymentSummary
				});

				return dispatch(updateBlockSuccessfulAction);
			} catch (error) {
				console.error(error);

				const hideBlockLoaderAction: HideBlockLoaderAction = {
					type: BlocksActionTypes.HIDE_BLOCK_LOADER
				};
				dispatch(hideBlockLoaderAction);
				const updateBlockFailedAction: UpdateBlockFailedAction = {
					type: BlocksActionTypes.UPDATE_BLOCK_FAILED
				};
				dispatch(updateBlockFailedAction);

				return Promise.reject(error);
			}
		},

	addMultipleProductsInQuoteBlockSection:
		(request: MultipleQuoteProductRequest) =>
		async (
			dispatch: Dispatch,
			getState: () => ProposalBuilderState
		): Promise<UpdateBlockSuccessfulAction> => {
			try {
				// show the loader
				const showBlockLoaderAction: ShowBlockLoaderAction = {
					type: BlocksActionTypes.SHOW_BLOCK_LOADER
				};
				dispatch(showBlockLoaderAction);
				const updateBlockRequestedAction: UpdateBlockRequestedAction = {
					type: BlocksActionTypes.UPDATE_BLOCK_REQUESTED
				};
				dispatch(updateBlockRequestedAction);

				const state = getState();

				const {
					blockId,
					sectionIndex,
					products: addedProducts,
					productIndex
				} = request;
				// get old block data
				const selectedBlock = cloneDeep(
					state.blocks.blockMapper[blockId]
				);
				const blockData = selectedBlock.data as QuoteBlockData;
				const sectionData = { ...blockData.sections[sectionIndex] };
				const addedProductIds = addedProducts.map(
					product => product.id
				);
				const existingProductIds = blockData.sections.reduce<
					(string | undefined)[]
				>((result, section) => {
					const ids = section.products.map(product => product.id);

					return [...result, ...ids];
				}, []);
				const alreadyExistingProductIdsInSection =
					addedProductIds.filter(id =>
						existingProductIds.includes(id)
					);

				if (!!productIndex) {
					const updatedProducts = [...sectionData.products];
					// Insert the addedProducts at the specified index
					updatedProducts.splice(
						productIndex,
						0,
						...addedProducts.map(product =>
							alreadyExistingProductIdsInSection.includes(
								product.id
							)
								? {
										...product,
										id: undefined
								  }
								: product
						)
					);
					// Update sectionData.products with the modified array
					sectionData.products = updatedProducts;
				} else {
					// update the block
					sectionData.products = [
						...sectionData.products,
						...addedProducts.map(product =>
							alreadyExistingProductIdsInSection.includes(
								product.id
							)
								? {
										...product,
										id: undefined
								  }
								: product
						)
					];
				}
				if (sectionData.type === QuoteSectionTypes.MANDATORY) {
					sectionData.selected_products = sectionData.products
						.map(a => a.id)
						.filter(Boolean) as string[];
				} else if (sectionData.type === QuoteSectionTypes.SINGLE) {
					sectionData.selected_products = !!sectionData?.products?.[0]
						?.id?.length
						? [sectionData.products[0].id]
						: [];
				} else {
					sectionData.selected_products = [
						...sectionData.selected_products
					];
				}

				// clone and assign to prevent read-only error
				const sections = [...blockData.sections];
				sections[sectionIndex] = sectionData;
				selectedBlock.data = {
					...blockData,
					sections
				};

				const updatedBlockResponse = await editBlock(selectedBlock);
				const { payment_summary: paymentSummary, ...updatedBlock } =
					updatedBlockResponse;
				// hide loader
				const hideBlockLoaderAction: HideBlockLoaderAction = {
					type: BlocksActionTypes.HIDE_BLOCK_LOADER
				};
				dispatch(hideBlockLoaderAction);

				// updating to the state
				const updateBlockSuccessfulAction: UpdateBlockSuccessfulAction =
					{
						type: BlocksActionTypes.UPDATE_BLOCK_SUCCESSFUL,
						blockData: updatedBlock,
						isQuoteBlock: true
					};

				// const updateCurrentDocPaymentSummarySuccessfulAction: UpdateCurrentDocPaymentSummarySuccessfulAction =
				// 	{
				// 		type: DocumentsActionTypes.UPDATE_CURRENT_DOC_PAYMENT_SUMMARY_SUCCESSFUL,
				// 		paymentSummary
				// 	};
				// dispatch(updateCurrentDocPaymentSummarySuccessfulAction);
				dispatch({
					type: ParentStateActionTypes.UPDATE_CURRENT_DOC_PAYMENT_SUMMARY_SUCCESSFUL,
					paymentSummary
				});
				return dispatch(updateBlockSuccessfulAction);
			} catch (error) {
				console.error(error);

				const hideBlockLoaderAction: HideBlockLoaderAction = {
					type: BlocksActionTypes.HIDE_BLOCK_LOADER
				};
				dispatch(hideBlockLoaderAction);
				const updateBlockFailedAction: UpdateBlockFailedAction = {
					type: BlocksActionTypes.UPDATE_BLOCK_FAILED
				};
				dispatch(updateBlockFailedAction);

				return Promise.reject(error);
			}
		},
	handleProductInQuoteBlockSelectChangeFromClient:
		({ blockId, sectionIndex, quoteProductId, checked }) =>
		async (
			dispatch: Dispatch,
			getState: () => ProposalBuilderState
		): Promise<UpdateBlockSuccessfulAction> => {
			try {
				// show the loader
				const showBlockLoaderAction: ShowBlockLoaderAction = {
					type: BlocksActionTypes.SHOW_BLOCK_LOADER
				};
				dispatch(showBlockLoaderAction);
				const updateBlockRequestedAction: UpdateBlockRequestedAction = {
					type: BlocksActionTypes.UPDATE_BLOCK_REQUESTED
				};
				dispatch(updateBlockRequestedAction);

				// get params from the state
				const state = getState();

				// get old block data
				const selectedBlock = cloneDeep(
					state.blocks.blockMapper[blockId]
				);
				const blockData = selectedBlock.data as QuoteBlockData;
				const sectionData = { ...blockData.sections[sectionIndex] };

				// updating the selected products
				if (sectionData.type === QuoteSectionTypes.MULTIPLE) {
					if (checked) {
						sectionData.selected_products.push(quoteProductId);
					} else {
						sectionData.selected_products =
							sectionData.selected_products.filter(
								productId => productId !== quoteProductId
							);
					}
				} else {
					if (checked) {
						sectionData.selected_products = [quoteProductId];
					}
				}

				const currentActiveDocument =
					state.parentState.currentActiveDocument;

				const isGenericOrderForm =
					currentActiveDocument?.document_type ===
					DocumentType.GENERIC_ORDER_FORM;

				// update the block
				blockData.sections[sectionIndex] = sectionData;
				const response = isGenericOrderForm
					? await editBlockFromPublicClient(
							selectedBlock,
							currentActiveDocument?.company_id
					  )
					: await editBlockFromClient(selectedBlock);

				// hide loader
				const hideBlockLoaderAction: HideBlockLoaderAction = {
					type: BlocksActionTypes.HIDE_BLOCK_LOADER
				};
				dispatch(hideBlockLoaderAction);
				const { payment_summary: paymentSummary, ...newBlockData } =
					response;

				// handling gof block changes
				const isClientUser =
					getQueryParamAuthDetails()?.queryParam?.includes(
						QueryParamConstants.CLIENT_USER_ID
					);

				if (
					isGenericOrderForm &&
					currentActiveDocument &&
					isClientUser
				) {
					newBlockData.updated = selectedBlock.updated;
					setGOFBlockData(currentActiveDocument, newBlockData);
					const blockList = getGOFDocumentData(
						currentActiveDocument?.id
					);
					const request = new GOFPaymentSummaryRequestData();
					request.blocks_metadata_gof = blockList?.blocks ?? [];
					const response = await calculatePaymentSummary(
						request,
						currentActiveDocument?.company_id
					);
					setGOFPaymentData(currentActiveDocument?.id, response);
					if (currentActiveDocument?.payment) {
						dispatch({
							type: ParentStateActionTypes.UPDATE_CURRENT_ACTIVE_DOCUMENT,
							currentActiveDocument: {
								...currentActiveDocument,
								payment: response
							}
						});
					}
				}
				// updating to the state
				const updateBlockSuccessfulAction: UpdateBlockSuccessfulAction =
					{
						type: BlocksActionTypes.UPDATE_BLOCK_SUCCESSFUL,
						blockData: newBlockData,
						isQuoteBlock: newBlockData.type === BlockType.QUOTE
					};
				// const updateCurrentDocPaymentSummarySuccessfulAction: UpdateCurrentDocPaymentSummarySuccessfulAction =
				// 	{
				// 		type: DocumentsActionTypes.UPDATE_CURRENT_DOC_PAYMENT_SUMMARY_SUCCESSFUL,
				// 		paymentSummary
				// 	};
				// dispatch(updateCurrentDocPaymentSummarySuccessfulAction);
				dispatch({
					type: ParentStateActionTypes.UPDATE_CURRENT_DOC_PAYMENT_SUMMARY_SUCCESSFUL,
					paymentSummary
				});
				return dispatch(updateBlockSuccessfulAction);
			} catch (error) {
				console.error(error);

				const hideBlockLoaderAction: HideBlockLoaderAction = {
					type: BlocksActionTypes.HIDE_BLOCK_LOADER
				};
				dispatch(hideBlockLoaderAction);
				const updateBlockFailedAction: UpdateBlockFailedAction = {
					type: BlocksActionTypes.UPDATE_BLOCK_FAILED
				};
				dispatch(updateBlockFailedAction);
				throw error;
			}
		},
	cloneBlock:
		({
			blockId,
			destinationDocumentId
		}: {
			blockId: string;
			destinationDocumentId?: string;
		}) =>
		async (dispatch: Dispatch): Promise<CloneBlockSuccessfulAction> => {
			try {
				const cloneBlockRequested: CloneBlockRequestedAction = {
					type: BlocksActionTypes.CLONE_BLOCK_REQUESTED
				};
				dispatch(cloneBlockRequested);

				const blockResponse = await cloneBlock({
					block_id: blockId,
					destination_document_id: destinationDocumentId
				});

				const cloneBlockSuccessfulAction: CloneBlockSuccessfulAction = {
					type: BlocksActionTypes.CLONE_BLOCK_SUCCESSFUL,
					block: blockResponse
				};
				return dispatch(cloneBlockSuccessfulAction);
			} catch (error) {
				const cloneBlockFailedAction: CloneBlockFailedAction = {
					type: BlocksActionTypes.CLONE_BLOCK_FAILED
				};
				dispatch(cloneBlockFailedAction);

				return Promise.reject(error);
			}
		},
	createBlockFromLibrary:
		({
			blockId,
			destinationDocumentId
		}: {
			blockId: string;
			destinationDocumentId?: string;
		}) =>
		async (
			dispatch: Dispatch
		): Promise<CreateBlockFromLibrarySuccessfulAction> => {
			try {
				const createBlockFromLibraryRequestedAction: CreateBlockFromLibraryRequestedAction =
					{
						type: BlocksActionTypes.CREATE_BLOCK_FROM_LIBRARY_REQUESTED
					};
				dispatch(createBlockFromLibraryRequestedAction);

				const blockCloneResponse = await cloneBlock({
					block_id: blockId,
					destination_document_id: destinationDocumentId
				});

				const createBlockFromLibrarySuccessfulAction: CreateBlockFromLibrarySuccessfulAction =
					{
						type: BlocksActionTypes.CREATE_BLOCK_FROM_LIBRARY_SUCCESSFUL,
						clonedBlockId: blockCloneResponse.id
					};
				return dispatch(createBlockFromLibrarySuccessfulAction);
			} catch (error) {
				const cloneBlockFailedAction: CreateBlockFromLibraryFailedAction =
					{
						type: BlocksActionTypes.CREATE_BLOCK_FROM_LIBRARY_FAILED
					};
				dispatch(cloneBlockFailedAction);

				return Promise.reject(error);
			}
		},
	updateDocumentBlockMapper:
		() =>
		async (
			dispatch: Dispatch,
			getState: () => ProposalBuilderState
		): Promise<UpdateBlockMapperSuccessfulAction> => {
			try {
				const updateBlockMapperRequestedAction: UpdateBlockMapperRequestedAction =
					{
						type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_REQUESTED
					};
				dispatch(updateBlockMapperRequestedAction);

				// fetch all the block related to the cloned block
				const currDocument =
					getState().parentState.currentActiveDocument;

				if (!currDocument) {
					throw new Error(
						"There is no active document to apply updates on"
					);
				}

				const documentId = currDocument.id;
				const latestRevision = Document.getLatestRevision(currDocument);

				if (!latestRevision) {
					throw new Error(
						"There is no active revision to apply updates on"
					);
				}

				const allBlocksResponse = await getBlockList(
					documentId,
					latestRevision.revision_id,
					null,
					null
				);

				const newBlockMapper: BlockMapper =
					allBlocksResponse.data.reduce(
						(total: BlockMapper, curr: Block) => ({
							...total,
							[curr.id]: curr
						}),
						{}
					);

				if (
					currDocument.is_single_block &&
					!!latestRevision?.rich_text_block_id &&
					latestRevision?.rich_text_block
				) {
					newBlockMapper[latestRevision.rich_text_block_id] =
						latestRevision?.rich_text_block ?? null;
				}

				const mergeTags = currDocument.merge_tag_system_variables;

				Object.keys(newBlockMapper).forEach(blockId => {
					if (
						newBlockMapper[blockId]?.type === BlockType.TEXT &&
						mergeTags?.length
					) {
						newBlockMapper[blockId] = {
							...newBlockMapper[blockId],
							data: {
								...newBlockMapper[blockId].data,
								text: updateMergeTagsDisplayName(
									mergeTags,
									(
										newBlockMapper[blockId]
											.data as TextBlockData
									).text
								)
							}
						};
					}
				});

				const updateBlockMapperSuccessfulAction: UpdateBlockMapperSuccessfulAction =
					{
						type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_SUCCESSFUL,
						blockMapper: newBlockMapper
					};
				return dispatch(updateBlockMapperSuccessfulAction);
			} catch (error) {
				const cloneBlockFailedAction: UpdateBlockMapperFailedAction = {
					type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_FAILED
				};
				dispatch(cloneBlockFailedAction);

				return Promise.reject(error);
			}
		},
	fetchMissingBlockAndAddToMapper:
		(blockId: string) =>
		async (
			dispatch: Dispatch,
			getState: () => ProposalBuilderState
		): Promise<FetchSingleBlockSuccessfulAction> => {
			try {
				const fetchSingleBlockRequestedAction: FetchSingleBlockRequestedAction =
					{
						type: BlocksActionTypes.FETCH_SINGLE_BLOCK_REQUESTED
					};
				dispatch(fetchSingleBlockRequestedAction);

				// fetch the single block by ID
				const block = await getBlock(blockId);
				// handle merge tag processing for text blocks
				const currDocument =
					getState().parentState.currentActiveDocument;
				const mergeTags = currDocument?.merge_tag_system_variables;

				if (
					block.type === BlockType.TEXT &&
					mergeTags?.length &&
					block.data
				) {
					block.data = {
						...block.data,
						text: updateMergeTagsDisplayName(
							mergeTags,
							(block.data as TextBlockData).text
						)
					};
				}

				const fetchSingleBlockSuccessfulAction: FetchSingleBlockSuccessfulAction =
					{
						type: BlocksActionTypes.FETCH_SINGLE_BLOCK_SUCCESSFUL,
						block: block
					};
				return dispatch(fetchSingleBlockSuccessfulAction);
			} catch (error) {
				const fetchSingleBlockFailedAction: FetchSingleBlockFailedAction =
					{
						type: BlocksActionTypes.FETCH_SINGLE_BLOCK_FAILED
					};
				dispatch(fetchSingleBlockFailedAction);

				return Promise.reject(error);
			}
		},
	editQuoteLabel: (
		blockId: string,
		key: keyof QuoteLabels,
		value: string,
		setAsGlobal: boolean,
		productIndex: number,
		sectionIndex: number
	) => {
		return async (
			dispatch: Dispatch,
			getState: () => ProposalBuilderState
		): Promise<EditQuoteLabelSuccessfulAction> => {
			const state = getState();
			const currentBlock = cloneDeep(state.blocks.blockMapper[blockId]);
			const editQuoteLabelRequestedAction: EditQuoteLabelRequestedAction =
				{
					type: BlocksActionTypes.EDIT_QUOTE_LABEL_REQUESTED
				};
			dispatch(editQuoteLabelRequestedAction);
			try {
				if (!(currentBlock && currentBlock.type === BlockType.QUOTE)) {
					throw new Error("The current block is not a quote block!");
				}
				const blockData = currentBlock.data as QuoteBlockData;
				const newSectionsData = blockData.sections.map(
					(section, sIndex) => {
						if (sIndex === sectionIndex) {
							const newProductData = section.products.map(
								(product, pIndex) => {
									if (pIndex === productIndex) {
										return { ...product, [key]: value };
									} else {
										return product;
									}
								}
							);
							return { ...section, products: newProductData };
						} else {
							return section;
						}
					}
				);
				const newBlockData: QuoteBlockData = {
					...blockData,
					label: {
						...DefaultQuoteLabels,
						...blockData.label,
						[key]:
							key === "additional_setup_price_label"
								? setAsGlobal
									? value
									: blockData?.label
											?.additional_setup_price_label
								: value
					},
					additional_setup_price_consistent:
						key === "additional_setup_price_label"
							? setAsGlobal
							: blockData.additional_setup_price_consistent,
					sections: newSectionsData
				};
				const newBlock: Block = { ...currentBlock, data: newBlockData };
				editBlock(newBlock);
				const editQuoteLabelSuccessfulAction: EditQuoteLabelSuccessfulAction =
					{
						type: BlocksActionTypes.EDIT_QUOTE_LABEL_SUCCESSFUL,
						blockData: newBlock
					};
				return dispatch(editQuoteLabelSuccessfulAction);
			} catch (error) {
				const editQuoteLabelFailedAction: EditQuoteLabelFailedAction = {
					type: BlocksActionTypes.EDIT_QUOTE_LABEL_FAILED
				};
				dispatch(editQuoteLabelFailedAction);

				return Promise.reject(error);
			}
		};
	},
	updateQuoteBlockLoaderIds:
		(quoteBlockIds: string[]) =>
		(dispatch: Dispatch): UpdateQuoteBlockLoaderIdsAction => {
			const updateQuoteBlockLoaderIdsAction: UpdateQuoteBlockLoaderIdsAction =
				{
					type: BlocksActionTypes.UPDATE_QUOTE_BLOCK_LOADER_IDS,
					quoteBlockIds: quoteBlockIds
				};

			return dispatch(updateQuoteBlockLoaderIdsAction);
		},
	showInputFieldPopUp: () => {
		return (dispatch: Dispatch): ShowInputFieldPopUp => {
			const showInputFieldPopUp: ShowInputFieldPopUp = {
				type: BlocksActionTypes.SHOW_INPUT_FIELD_POP_UP
			};
			return dispatch(showInputFieldPopUp);
		};
	},
	hideInputFieldPopUp: () => {
		return (dispatch: Dispatch): HideInputFieldPopUp => {
			const hideInputFieldPopUp: HideInputFieldPopUp = {
				type: BlocksActionTypes.HIDE_INPUT_FIELD_POP_UP
			};
			return dispatch(hideInputFieldPopUp);
		};
	},
	showBackgroundColorPicker: () => {
		return (dispatch: Dispatch): ShowBackgroundColorPicker => {
			const showBackgroundColorPicker: ShowBackgroundColorPicker = {
				type: BlocksActionTypes.SHOW_BACKGROUND_COLOR_PICKER
			};
			return dispatch(showBackgroundColorPicker);
		};
	},
	hideBackgroundColorPicker: () => {
		return (dispatch: Dispatch): HideBackgroundColorPicker => {
			const hideBackgroundColorPicker: HideBackgroundColorPicker = {
				type: BlocksActionTypes.HIDE_BACKGROUND_COLOR_PICKER
			};
			return dispatch(hideBackgroundColorPicker);
		};
	},
	showProductConfigureDrawer: (
		sectionIndex: number,
		blockId: string,
		productData: QuoteProduct,
		readonly?: boolean
	) => {
		return (dispatch: Dispatch): ShowProductConfigureDrawer => {
			const showProductConfigureDrawer: ShowProductConfigureDrawer = {
				type: BlocksActionTypes.SHOW_PRODUCT_CONFIGURE_DRAWER,
				sectionIndex: sectionIndex,
				blockId: blockId,
				productData: productData,
				readonly: readonly ?? false
			};
			return dispatch(showProductConfigureDrawer);
		};
	},
	hideProductConfigureDrawer: () => {
		return (dispatch: Dispatch): HideProductConfigureDrawer => {
			const hideProductConfigureDrawer: HideProductConfigureDrawer = {
				type: BlocksActionTypes.HIDE_PRODUCT_CONFIGURE_DRAWER
			};
			return dispatch(hideProductConfigureDrawer);
		};
	},
	showImportProductsToQuoteDrawer: (
		blockId: string,
		sectionIndex: number
	) => {
		return (dispatch: Dispatch): ShowImportProductsToQuoteDrawer => {
			const showImportProductsToQuoteDrawer: ShowImportProductsToQuoteDrawer =
				{
					type: BlocksActionTypes.SHOW_IMPORT_PRODUCTS_TO_QUOTE_DRAWER,
					blockId: blockId,
					sectionIndex: sectionIndex
				};
			return dispatch(showImportProductsToQuoteDrawer);
		};
	},
	hideImportProductsToQuoteDrawer: () => {
		return (dispatch: Dispatch): HideImportProductsToQuoteDrawer => {
			const hideImportProductsToQuoteDrawer: HideImportProductsToQuoteDrawer =
				{
					type: BlocksActionTypes.HIDE_IMPORT_PRODUCTS_TO_QUOTE_DRAWER
				};
			return dispatch(hideImportProductsToQuoteDrawer);
		};
	},
	updateEditorType: (editorType: EditorType) => {
		return (dispatch: Dispatch): UpdateEditorType => {
			const updateEditorType: UpdateEditorType = {
				type: BlocksActionTypes.UPDATE_EDITOR_TYPE,
				editorType
			};
			return dispatch(updateEditorType);
		};
	},
	updateHeaderFooterColumnId: (headerFooterColumnId: string | null) => {
		return (dispatch: Dispatch): UpdateHeaderFooterColumnId => {
			const updateHeaderFooterColumnId: UpdateHeaderFooterColumnId = {
				type: BlocksActionTypes.UPDATE_HEADER_FOOTER_COLUMN_ID,
				headerFooterColumnId
			};
			return dispatch(updateHeaderFooterColumnId);
		};
	}
};

export default BlocksActionCreators;
